function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e13) { throw _e13; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e14) { didErr = true; err = _e14; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Wavoip = e() : t.Wavoip = e();
}(window, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 11);
  }([function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return n;
    });
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : Function("return this")();
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      if (t) return function (t) {
        for (var e in n.prototype) {
          t[e] = n.prototype[e];
        }

        return t;
      }(t);
    }

    r.d(e, "a", function () {
      return n;
    }), n.prototype.on = n.prototype.addEventListener = function (t, e) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
    }, n.prototype.once = function (t, e) {
      function r() {
        this.off(t, r), e.apply(this, arguments);
      }

      return r.fn = e, this.on(t, r), this;
    }, n.prototype.off = n.prototype.removeListener = n.prototype.removeAllListeners = n.prototype.removeEventListener = function (t, e) {
      if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
      var r,
          n = this._callbacks["$" + t];
      if (!n) return this;
      if (1 == arguments.length) return delete this._callbacks["$" + t], this;

      for (var o = 0; o < n.length; o++) {
        if ((r = n[o]) === e || r.fn === e) {
          n.splice(o, 1);
          break;
        }
      }

      return 0 === n.length && delete this._callbacks["$" + t], this;
    }, n.prototype.emit = function (t) {
      this._callbacks = this._callbacks || {};

      for (var e = new Array(arguments.length - 1), r = this._callbacks["$" + t], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }

      if (r) {
        n = 0;

        for (var o = (r = r.slice(0)).length; n < o; ++n) {
          r[n].apply(this, e);
        }
      }

      return this;
    }, n.prototype.emitReserved = n.prototype.emit, n.prototype.listeners = function (t) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
    }, n.prototype.hasListeners = function (t) {
      return !!this.listeners(t).length;
    };
  }, function (t, e, r) {
    "use strict";

    r.d(e, "c", function () {
      return o;
    }), r.d(e, "b", function () {
      return a;
    }), r.d(e, "a", function () {
      return c;
    });
    var n = r(0);

    function o(t) {
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }

      return e.reduce(function (e, r) {
        return t.hasOwnProperty(r) && (e[r] = t[r]), e;
      }, {});
    }

    var i = n.a.setTimeout,
        s = n.a.clearTimeout;

    function a(t, e) {
      e.useNativeTimers ? (t.setTimeoutFn = i.bind(n.a), t.clearTimeoutFn = s.bind(n.a)) : (t.setTimeoutFn = n.a.setTimeout.bind(n.a), t.clearTimeoutFn = n.a.clearTimeout.bind(n.a));
    }

    function c(t) {
      return "string" == typeof t ? function (t) {
        var e = 0,
            r = 0;

        for (var _n = 0, _o = t.length; _n < _o; _n++) {
          e = t.charCodeAt(_n), e < 128 ? r += 1 : e < 2048 ? r += 2 : e < 55296 || e >= 57344 ? r += 3 : (_n++, r += 4);
        }

        return r;
      }(t) : Math.ceil(1.33 * (t.byteLength || t.size));
    }
  }, function (t, e, r) {
    "use strict";

    r.d(e, "c", function () {
      return o;
    }), r.d(e, "a", function () {
      return i;
    }), r.d(e, "d", function () {
      return s;
    }), r.d(e, "b", function () {
      return a;
    });
    var n = r(0);
    var o = "function" == typeof Promise && "function" == typeof Promise.resolve ? function (t) {
      return Promise.resolve().then(t);
    } : function (t, e) {
      return e(t, 0);
    },
        i = n.a.WebSocket || n.a.MozWebSocket,
        s = !0,
        a = "arraybuffer";
  }, function (t, e, r) {
    "use strict";

    r.d(e, "e", function () {
      return b;
    }), r.d(e, "c", function () {
      return u;
    }), r.d(e, "d", function () {
      return v;
    }), r.d(e, "a", function () {
      return y;
    }), r.d(e, "b", function () {
      return m;
    });
    var n = Object.create(null);
    n.open = "0", n.close = "1", n.ping = "2", n.pong = "3", n.message = "4", n.upgrade = "5", n.noop = "6";
    var o = Object.create(null);
    Object.keys(n).forEach(function (t) {
      o[n[t]] = t;
    });

    var i = {
      type: "error",
      data: "parser error"
    },
        s = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === Object.prototype.toString.call(Blob),
        a = "function" == typeof ArrayBuffer,
        c = function c(t, e) {
      var r = new FileReader();
      return r.onload = function () {
        var t = r.result.split(",")[1];
        e("b" + (t || ""));
      }, r.readAsDataURL(t);
    };

    var u = function u(_ref, r, o) {
      var t = _ref.type,
          e = _ref.data;
      return s && e instanceof Blob ? r ? o(e) : c(e, o) : a && (e instanceof ArrayBuffer || (i = e, "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(i) : i && i.buffer instanceof ArrayBuffer)) ? r ? o(e) : c(new Blob([e]), o) : o(n[t] + (e || ""));
      var i;
    };

    var h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
        f = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256);

    for (var _t2 = 0; _t2 < h.length; _t2++) {
      f[h.charCodeAt(_t2)] = _t2;
    }

    var l = "function" == typeof ArrayBuffer,
        p = function p(t, e) {
      if (l) {
        var _r = function (t) {
          var e,
              r,
              n,
              o,
              i,
              s = .75 * t.length,
              a = t.length,
              c = 0;
          "=" === t[t.length - 1] && (s--, "=" === t[t.length - 2] && s--);
          var u = new ArrayBuffer(s),
              h = new Uint8Array(u);

          for (e = 0; e < a; e += 4) {
            r = f[t.charCodeAt(e)], n = f[t.charCodeAt(e + 1)], o = f[t.charCodeAt(e + 2)], i = f[t.charCodeAt(e + 3)], h[c++] = r << 2 | n >> 4, h[c++] = (15 & n) << 4 | o >> 2, h[c++] = (3 & o) << 6 | 63 & i;
          }

          return u;
        }(t);

        return d(_r, e);
      }

      return {
        base64: !0,
        data: t
      };
    },
        d = function d(t, e) {
      switch (e) {
        case "blob":
          return t instanceof ArrayBuffer ? new Blob([t]) : t;

        case "arraybuffer":
        default:
          return t;
      }
    };

    var y = function y(t, e) {
      if ("string" != typeof t) return {
        type: "message",
        data: d(t, e)
      };
      var r = t.charAt(0);
      if ("b" === r) return {
        type: "message",
        data: p(t.substring(1), e)
      };
      return o[r] ? t.length > 1 ? {
        type: o[r],
        data: t.substring(1)
      } : {
        type: o[r]
      } : i;
    };

    var g = String.fromCharCode(30),
        v = function v(t, e) {
      var r = t.length,
          n = new Array(r);
      var o = 0;
      t.forEach(function (t, i) {
        u(t, !1, function (t) {
          n[i] = t, ++o === r && e(n.join(g));
        });
      });
    },
        m = function m(t, e) {
      var r = t.split(g),
          n = [];

      for (var _t3 = 0; _t3 < r.length; _t3++) {
        var _o2 = y(r[_t3], e);

        if (n.push(_o2), "error" === _o2.type) break;
      }

      return n;
    },
        b = 4;
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return a;
    });
    var n = r(4),
        o = r(1),
        i = r(2);

    var s = /*#__PURE__*/function (_Error) {
      _inherits(s, _Error);

      var _super = _createSuper(s);

      function s(t, e, r) {
        var _this;

        _classCallCheck(this, s);

        _this = _super.call(this, t), _this.description = e, _this.context = r, _this.type = "TransportError";
        return _this;
      }

      return s;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    var a = /*#__PURE__*/function (_o$a) {
      _inherits(a, _o$a);

      var _super2 = _createSuper(a);

      function a(t) {
        var _this2;

        _classCallCheck(this, a);

        _this2 = _super2.call(this), _this2.writable = !1, Object(i.b)(_assertThisInitialized(_this2), t), _this2.opts = t, _this2.query = t.query, _this2.socket = t.socket;
        return _this2;
      }

      _createClass(a, [{
        key: "onError",
        value: function onError(t, e, r) {
          return _get(_getPrototypeOf(a.prototype), "emitReserved", this).call(this, "error", new s(t, e, r)), this;
        }
      }, {
        key: "open",
        value: function open() {
          return this.readyState = "opening", this.doOpen(), this;
        }
      }, {
        key: "close",
        value: function close() {
          return "opening" !== this.readyState && "open" !== this.readyState || (this.doClose(), this.onClose()), this;
        }
      }, {
        key: "send",
        value: function send(t) {
          "open" === this.readyState && this.write(t);
        }
      }, {
        key: "onOpen",
        value: function onOpen() {
          this.readyState = "open", this.writable = !0, _get(_getPrototypeOf(a.prototype), "emitReserved", this).call(this, "open");
        }
      }, {
        key: "onData",
        value: function onData(t) {
          var e = Object(n.a)(t, this.socket.binaryType);
          this.onPacket(e);
        }
      }, {
        key: "onPacket",
        value: function onPacket(t) {
          _get(_getPrototypeOf(a.prototype), "emitReserved", this).call(this, "packet", t);
        }
      }, {
        key: "onClose",
        value: function onClose(t) {
          this.readyState = "closed", _get(_getPrototypeOf(a.prototype), "emitReserved", this).call(this, "close", t);
        }
      }, {
        key: "pause",
        value: function pause(t) {}
      }]);

      return a;
    }(o.a);
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = "";

      for (var _r2 in t) {
        t.hasOwnProperty(_r2) && (e.length && (e += "&"), e += encodeURIComponent(_r2) + "=" + encodeURIComponent(t[_r2]));
      }

      return e;
    }

    function o(t) {
      var e = {},
          r = t.split("&");

      for (var _t4 = 0, _n2 = r.length; _t4 < _n2; _t4++) {
        var _n3 = r[_t4].split("=");

        e[decodeURIComponent(_n3[0])] = decodeURIComponent(_n3[1]);
      }

      return e;
    }

    r.d(e, "b", function () {
      return n;
    }), r.d(e, "a", function () {
      return o;
    });
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return u;
    });
    var n = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""),
        o = {};
    var i,
        s = 0,
        a = 0;

    function c(t) {
      var e = "";

      do {
        e = n[t % 64] + e, t = Math.floor(t / 64);
      } while (t > 0);

      return e;
    }

    function u() {
      var t = c(+new Date());
      return t !== i ? (s = 0, i = t) : t + "." + c(s++);
    }

    for (; a < 64; a++) {
      o[n[a]] = a;
    }
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      r.d(e, "a", function () {
        return h;
      });
      var n = r(5),
          o = r(6),
          i = r(7),
          s = r(2),
          a = r(3),
          c = r(4);
      var u = "undefined" != typeof navigator && "string" == typeof navigator.product && "reactnative" === navigator.product.toLowerCase();

      var h = /*#__PURE__*/function (_n$a) {
        _inherits(h, _n$a);

        var _super3 = _createSuper(h);

        function h(t) {
          var _this3;

          _classCallCheck(this, h);

          _this3 = _super3.call(this, t), _this3.supportsBinary = !t.forceBase64;
          return _this3;
        }

        _createClass(h, [{
          key: "name",
          get: function get() {
            return "websocket";
          }
        }, {
          key: "doOpen",
          value: function doOpen() {
            if (!this.check()) return;
            var t = this.uri(),
                e = this.opts.protocols,
                r = u ? {} : Object(s.c)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
            this.opts.extraHeaders && (r.headers = this.opts.extraHeaders);

            try {
              this.ws = a.d && !u ? e ? new a.a(t, e) : new a.a(t) : new a.a(t, e, r);
            } catch (t) {
              return this.emitReserved("error", t);
            }

            this.ws.binaryType = this.socket.binaryType || a.b, this.addEventListeners();
          }
        }, {
          key: "addEventListeners",
          value: function addEventListeners() {
            var _this4 = this;

            this.ws.onopen = function () {
              _this4.opts.autoUnref && _this4.ws._socket.unref(), _this4.onOpen();
            }, this.ws.onclose = function (t) {
              return _this4.onClose({
                description: "websocket connection closed",
                context: t
              });
            }, this.ws.onmessage = function (t) {
              return _this4.onData(t.data);
            }, this.ws.onerror = function (t) {
              return _this4.onError("websocket error", t);
            };
          }
        }, {
          key: "write",
          value: function write(e) {
            var _this5 = this;

            this.writable = !1;

            var _loop = function _loop(_r3) {
              var n = e[_r3],
                  o = _r3 === e.length - 1;
              Object(c.c)(n, _this5.supportsBinary, function (e) {
                var r = {};

                if (!a.d && (n.options && (r.compress = n.options.compress), _this5.opts.perMessageDeflate)) {
                  ("string" == typeof e ? t.byteLength(e) : e.length) < _this5.opts.perMessageDeflate.threshold && (r.compress = !1);
                }

                try {
                  a.d ? _this5.ws.send(e) : _this5.ws.send(e, r);
                } catch (t) {}

                o && Object(a.c)(function () {
                  _this5.writable = !0, _this5.emitReserved("drain");
                }, _this5.setTimeoutFn);
              });
            };

            for (var _r3 = 0; _r3 < e.length; _r3++) {
              _loop(_r3);
            }
          }
        }, {
          key: "doClose",
          value: function doClose() {
            void 0 !== this.ws && (this.ws.close(), this.ws = null);
          }
        }, {
          key: "uri",
          value: function uri() {
            var t = this.query || {};
            var e = this.opts.secure ? "wss" : "ws";
            var r = "";
            this.opts.port && ("wss" === e && 443 !== Number(this.opts.port) || "ws" === e && 80 !== Number(this.opts.port)) && (r = ":" + this.opts.port), this.opts.timestampRequests && (t[this.opts.timestampParam] = Object(i.a)()), this.supportsBinary || (t.b64 = 1);
            var n = Object(o.b)(t);
            return e + "://" + (-1 !== this.opts.hostname.indexOf(":") ? "[" + this.opts.hostname + "]" : this.opts.hostname) + r + this.opts.path + (n.length ? "?" + n : "");
          }
        }, {
          key: "check",
          value: function check() {
            return !!a.a;
          }
        }]);

        return h;
      }(n.a);
    }).call(this, r(12).Buffer);
  }, function (t, e, r) {
    t.exports = r(17)('!function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=0)}([function(t,e){class r extends AudioWorkletProcessor{constructor(t){super(t),Object.assign(this,t.processorOptions,{uint8:new Uint8Array(0)}),this.port.onmessage=this.appendBuffers.bind(this)}async appendBuffers({data:{buffer:t}}){const e=new Uint8Array(this.uint8.length+t.length);return e.set(this.uint8,0),e.set(t,this.uint8.length),this.uint8=e,!0}endOfStream(){this.port.postMessage({ended:!0,currentTime:currentTime,currentFrame:currentFrame})}process(t,e){const r=e[0];if(this.offset>=this.uint8.length)return!0;const n=new Uint8Array(256);for(let t=0;t<256&&!(this.offset>=this.uint8.length);t++,this.offset++)n[t]=this.uint8[this.offset];const o=new Uint16Array(n.buffer);for(let t=0;t<o.length;t++){const e=o[t],n=e>=32768?-(65536-e)/32768:e/32767;r[0][t]=n}return!0}}registerProcessor("audio-data-worklet-stream",r)}]);');
  }, function (t, e, r) {
    var n;
    self, n = function n() {
      return function () {
        var t = {
          163: function _(t, e, r) {
            t.exports = r(252)('(()=>{class s extends AudioWorkletProcessor{static get parameterDescriptors(){return[]}constructor(){super(),this.chunks=[],this.port.onmessage=s=>{const t=s.data;switch(t.type){case"init":this.config=t.data;break;case"stop":const s=this.splitChunksByProcessSize();this.port.postMessage({type:"process",data:s})}}}compress(s,t){let e=Math.floor(s.length+t.length),r=new Float32Array(e),o=0,c=0;for(;o<e;){let e=Math.floor(c);r[o]=s[e],o++,t.length&&(r[o]=t[e],o++),c+=1}return r}getRMS(s){let t=0;for(let e=0;e<s.length;e++)t+=s[e]*s[e];return Math.sqrt(t/s.length)}splitChunksByProcessSize(){const s=this.chunks.splice(0,this.config.processSize);return{buffer:s,vol:this.getRMS(s)}}calculateVolume(s){let t=s[0][0],e=[];2===this.config.numChannels&&(e=s[0][1]);const r=this.compress(t,e);if(this.chunks.push(...r),this.chunks.length>=this.config.processSize){const s=this.splitChunksByProcessSize();this.port.postMessage({type:"process",data:s})}}process(s,t,e){return this.calculateVolume(s),!0}}registerProcessor("main",s)})();');
          },
          252: function _(t) {
            "use strict";

            var e = window.URL || window.webkitURL;

            t.exports = function (t) {
              try {
                var r;

                try {
                  (r = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)()).append(t), r = r.getBlob("application/javascript; charset=utf-8");
                } catch (e) {
                  r = new Blob([t], {
                    type: "application/javascript; charset=utf-8"
                  });
                }

                return e.createObjectURL(r);
              } catch (e) {
                return "data:application/javascript," + encodeURIComponent(t);
              }
            };
          }
        },
            e = {};

        function r(n) {
          var o = e[n];
          if (void 0 !== o) return o.exports;
          var i = e[n] = {
            exports: {}
          };
          return t[n](i, i.exports, r), i.exports;
        }

        r.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(e, {
            a: e
          }), e;
        }, r.d = function (t, e) {
          for (var n in e) {
            r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
              enumerable: !0,
              get: e[n]
            });
          }
        }, r.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        };
        var n = {};
        return function () {
          "use strict";

          r.d(n, {
            default: function _default() {
              return a;
            }
          });

          var t = r(163),
              e = r.n(t),
              o = function o(t, e, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(t) {
                try {
                  c(n.next(t));
                } catch (t) {
                  i(t);
                }
              }

              function a(t) {
                try {
                  c(n.throw(t));
                } catch (t) {
                  i(t);
                }
              }

              function c(t) {
                var e;
                t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                  t(e);
                })).then(s, a);
              }

              c((n = n.apply(t, e || [])).next());
            });
          },
              i = function i(t, e) {
            var r,
                n,
                o,
                i,
                s = {
              label: 0,
              sent: function sent() {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
            return i = {
              next: a(0),
              throw: a(1),
              return: a(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;

            function a(a) {
              return function (c) {
                return function (a) {
                  if (r) throw new TypeError("Generator is already executing.");

                  for (; i && (i = 0, a[0] && (s = 0)), s;) {
                    try {
                      if (r = 1, n && (o = 2 & a[0] ? n.return : a[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, a[1])).done) return o;

                      switch (n = 0, o && (a = [2 & a[0], o.value]), a[0]) {
                        case 0:
                        case 1:
                          o = a;
                          break;

                        case 4:
                          return s.label++, {
                            value: a[1],
                            done: !1
                          };

                        case 5:
                          s.label++, n = a[1], a = [0];
                          continue;

                        case 7:
                          a = s.ops.pop(), s.trys.pop();
                          continue;

                        default:
                          if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                            s = 0;
                            continue;
                          }

                          if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                            s.label = a[1];
                            break;
                          }

                          if (6 === a[0] && s.label < o[1]) {
                            s.label = o[1], o = a;
                            break;
                          }

                          if (o && s.label < o[2]) {
                            s.label = o[2], s.ops.push(a);
                            break;
                          }

                          o[2] && s.ops.pop(), s.trys.pop();
                          continue;
                      }

                      a = e.call(t, s);
                    } catch (t) {
                      a = [6, t], n = 0;
                    } finally {
                      r = o = 0;
                    }
                  }

                  if (5 & a[0]) throw a[1];
                  return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                  };
                }([a, c]);
              };
            }
          };

          function s(t, e, r) {
            for (var n = 0; n < r.length; n++) {
              t.setUint8(e + n, r.charCodeAt(n));
            }
          }

          var a = function () {
            function t() {
              var t;
              this.config = {
                processOptions: {
                  processSize: 4096,
                  numChannels: 1,
                  sampleBits: 16,
                  sampleRate: 16e3
                },
                analyserOptions: {
                  open: !1,
                  fftSize: 512
                }
              }, this.stream = null, this.context = null, this.workletNode = null, this.microphone = null, this.analyserNode = null, this.littleEdian = !1, this.status = "not ready", this.littleEdian = (t = new ArrayBuffer(2), new DataView(t).setInt16(0, 256, !0), 256 === new Int16Array(t)[0]);
            }

            return t.prototype.closeTracks = function () {
              var t, e;
              null === (e = null === (t = this.stream) || void 0 === t ? void 0 : t.getTracks()) || void 0 === e || e.forEach(function (t) {
                t.stop();
              });
            }, t.prototype.init = function (t) {
              return o(this, void 0, void 0, function () {
                var e, r;
                return i(this, function (n) {
                  return "recording" === this.status ? [2, console.warn("录音中，请不要初始化，这会导致音频处理错误")] : (e = Object.assign(this.config.processOptions, null == t ? void 0 : t.processOptions), r = Object.assign(this.config.analyserOptions, null == t ? void 0 : t.analyserOptions), Object.assign(this.config, t), this.config.processOptions = e, this.config.analyserOptions = r, this.status = "ready", [2]);
                });
              });
            }, t.prototype.stop = function () {
              var t, e, r;
              return o(this, void 0, void 0, function () {
                var n;
                return i(this, function (o) {
                  switch (o.label) {
                    case 0:
                      return "recording" !== this.status ? [2, console.warn("当前没有在录音")] : (this.workletNode.port.postMessage({
                        type: "stop"
                      }), n = null === (t = this.context) || void 0 === t ? void 0 : t.currentTime, this.closeTracks(), "closed" === (null === (e = this.context) || void 0 === e ? void 0 : e.state) ? [3, 2] : [4, null === (r = this.context) || void 0 === r ? void 0 : r.close()]);

                    case 1:
                      o.sent(), o.label = 2;

                    case 2:
                      return this.microphone = null, this.stream = null, this.workletNode = null, this.context = null, this.status = "ready", [2, n];
                  }
                });
              });
            }, t.prototype.start = function () {
              var t, r, n;
              return o(this, void 0, void 0, function () {
                var o,
                    s = this;
                return i(this, function (i) {
                  switch (i.label) {
                    case 0:
                      return "not ready" === this.status ? [2, console.warn("没有初始化,请先调用init")] : "recording" === this.status ? [2, console.warn("正在录音中，请不要重复调用")] : (this.status = "recording", o = this, [4, navigator.mediaDevices.getUserMedia({
                        audio: !0
                      })]);

                    case 1:
                      return o.stream = i.sent(), this.context = new AudioContext({
                        sampleRate: null === (t = this.config.processOptions) || void 0 === t ? void 0 : t.sampleRate
                      }), [4, this.context.audioWorklet.addModule(e())];

                    case 2:
                      return i.sent(), this.microphone = this.context.createMediaStreamSource(this.stream), this.workletNode = new AudioWorkletNode(this.context, "main"), this.workletNode.port.postMessage({
                        type: "init",
                        data: {
                          processSize: null === (r = this.config.processOptions) || void 0 === r ? void 0 : r.processSize,
                          numChannels: null === (n = this.config.processOptions) || void 0 === n ? void 0 : n.numChannels,
                          sampleRate: this.context.sampleRate
                        }
                      }), this.workletNode.port.onmessage = function (t) {
                        var e,
                            r,
                            n = t.data;
                        "process" === n.type && (null === (e = s.config) || void 0 === e ? void 0 : e.onDataProcess) && (null === (r = s.config) || void 0 === r || r.onDataProcess({
                          vol: n.data.vol,
                          buffer: n.data.buffer
                        }));
                      }, this.microphone.connect(this.workletNode).connect(this.context.destination), this.config.analyserOptions.open && (this.analyserNode = this.context.createAnalyser(), this.analyserNode.fftSize = this.config.analyserOptions.fftSize, this.microphone.connect(this.analyserNode)), [2];
                  }
                });
              });
            }, t.prototype.encodePCM = function (t, e, r) {
              var n;
              void 0 === e && (e = null === (n = this.config.processOptions) || void 0 === n ? void 0 : n.sampleBits), void 0 === r && (r = this.littleEdian);
              var o = 0,
                  i = t.length * (e / 8),
                  s = new ArrayBuffer(i),
                  a = new DataView(s);
              if (8 === e) for (var c = 0; c < t.length; c++, o++) {
                var u = (h = Math.max(-1, Math.min(1, t[c]))) < 0 ? 128 * h : 127 * h;
                u = +u + 128, a.setInt8(o, u);
              } else for (c = 0; c < t.length; c++, o += 2) {
                var h = Math.max(-1, Math.min(1, t[c]));
                a.setInt16(o, h < 0 ? 32768 * h : 32767 * h, r);
              }
              return a;
            }, t.prototype.encodeWAV = function (t, e, r, n, o) {
              void 0 === e && (e = this.config.processOptions.sampleRate), void 0 === r && (r = this.config.processOptions.numChannels), void 0 === n && (n = this.config.processOptions.sampleBits), void 0 === o && (o = this.littleEdian);
              var i = n / 8,
                  a = r * i,
                  c = new ArrayBuffer(44 + t.byteLength * i),
                  u = new DataView(c),
                  h = 0;
              s(u, 0, "RIFF"), h += 4, u.setUint32(h, 36 + t.byteLength * i, o), s(u, h += 4, "WAVE"), s(u, h += 4, "fmt "), h += 4, u.setUint32(h, 16, o), h += 4, u.setUint16(h, 1, o), h += 2, u.setUint16(h, r, o), h += 2, u.setUint32(h, e, o), h += 4, u.setUint32(h, e * a, o), h += 4, u.setUint16(h, a, o), h += 2, u.setUint16(h, n, o), s(u, h += 2, "data"), h += 4, u.setUint32(h, t.byteLength, o), h += 4;

              for (var f = 0; f < t.byteLength;) {
                u.setUint8(h, t.getUint8(f)), h++, f++;
              }

              return u;
            }, t.prototype.getAnalyserData = function () {
              if (!this.config.analyserOptions.open) return console.warn("未开启analyser功能");
              if ("recording" !== this.status) return console.warn("当前未录音");
              var t = this.analyserNode.frequencyBinCount,
                  e = new Uint8Array(t);
              return this.analyserNode.getByteFrequencyData(e), e;
            }, t;
          }();
        }(), n.default;
      }();
    }, t.exports = n();
  }, function (t, e, r) {
    t.exports = r(18).default;
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var n = r(14),
          o = r(15),
          i = r(16);

      function s() {
        return c.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function a(t, e) {
        if (s() < e) throw new RangeError("Invalid typed array length");
        return c.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = c.prototype : (null === t && (t = new c(e)), t.length = e), t;
      }

      function c(t, e, r) {
        if (!(c.TYPED_ARRAY_SUPPORT || this instanceof c)) return new c(t, e, r);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return f(this, t);
        }

        return u(this, t, e, r);
      }

      function u(t, e, r, n) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
          if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
          c.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = c.prototype : t = l(t, e);
          return t;
        }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!c.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | d(e, r),
              o = (t = a(t, n)).write(e, r);
          o !== n && (t = t.slice(0, o));
          return t;
        }(t, e, r) : function (t, e) {
          if (c.isBuffer(e)) {
            var r = 0 | p(e.length);
            return 0 === (t = a(t, r)).length || e.copy(t, 0, 0, r), t;
          }

          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : l(t, e);
            if ("Buffer" === e.type && i(e.data)) return l(t, e.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(t, e);
      }

      function h(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function f(t, e) {
        if (h(e), t = a(t, e < 0 ? 0 : 0 | p(e)), !c.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
          t[r] = 0;
        }
        return t;
      }

      function l(t, e) {
        var r = e.length < 0 ? 0 : 0 | p(e.length);
        t = a(t, r);

        for (var n = 0; n < r; n += 1) {
          t[n] = 255 & e[n];
        }

        return t;
      }

      function p(t) {
        if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
        return 0 | t;
      }

      function d(t, e) {
        if (c.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var r = t.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return Y(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return q(t).length;

            default:
              if (n) return Y(t).length;
              e = ("" + e).toLowerCase(), n = !0;
          }
        }
      }

      function y(t, e, r) {
        var n = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return P(this, e, r);

            case "utf8":
            case "utf-8":
              return A(this, e, r);

            case "ascii":
              return x(this, e, r);

            case "latin1":
            case "binary":
              return R(this, e, r);

            case "base64":
              return S(this, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return T(this, e, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), n = !0;
          }
        }
      }

      function g(t, e, r) {
        var n = t[e];
        t[e] = t[r], t[r] = n;
      }

      function v(t, e, r, n, o) {
        if (0 === t.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = o ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
          if (o) return -1;
          r = t.length - 1;
        } else if (r < 0) {
          if (!o) return -1;
          r = 0;
        }

        if ("string" == typeof e && (e = c.from(e, n)), c.isBuffer(e)) return 0 === e.length ? -1 : m(t, e, r, n, o);
        if ("number" == typeof e) return e &= 255, c.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : m(t, [e], r, n, o);
        throw new TypeError("val must be string, number or Buffer");
      }

      function m(t, e, r, n, o) {
        var i,
            s = 1,
            a = t.length,
            c = e.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (t.length < 2 || e.length < 2) return -1;
          s = 2, a /= 2, c /= 2, r /= 2;
        }

        function u(t, e) {
          return 1 === s ? t[e] : t.readUInt16BE(e * s);
        }

        if (o) {
          var h = -1;

          for (i = r; i < a; i++) {
            if (u(t, i) === u(e, -1 === h ? 0 : i - h)) {
              if (-1 === h && (h = i), i - h + 1 === c) return h * s;
            } else -1 !== h && (i -= i - h), h = -1;
          }
        } else for (r + c > a && (r = a - c), i = r; i >= 0; i--) {
          for (var f = !0, l = 0; l < c; l++) {
            if (u(t, i + l) !== u(e, l)) {
              f = !1;
              break;
            }
          }

          if (f) return i;
        }

        return -1;
      }

      function b(t, e, r, n) {
        r = Number(r) || 0;
        var o = t.length - r;
        n ? (n = Number(n)) > o && (n = o) : n = o;
        var i = e.length;
        if (i % 2 != 0) throw new TypeError("Invalid hex string");
        n > i / 2 && (n = i / 2);

        for (var s = 0; s < n; ++s) {
          var a = parseInt(e.substr(2 * s, 2), 16);
          if (isNaN(a)) return s;
          t[r + s] = a;
        }

        return s;
      }

      function w(t, e, r, n) {
        return F(Y(e, t.length - r), t, r, n);
      }

      function _(t, e, r, n) {
        return F(function (t) {
          for (var e = [], r = 0; r < t.length; ++r) {
            e.push(255 & t.charCodeAt(r));
          }

          return e;
        }(e), t, r, n);
      }

      function k(t, e, r, n) {
        return _(t, e, r, n);
      }

      function E(t, e, r, n) {
        return F(q(e), t, r, n);
      }

      function O(t, e, r, n) {
        return F(function (t, e) {
          for (var r, n, o, i = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
            r = t.charCodeAt(s), n = r >> 8, o = r % 256, i.push(o), i.push(n);
          }

          return i;
        }(e, t.length - r), t, r, n);
      }

      function S(t, e, r) {
        return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
      }

      function A(t, e, r) {
        r = Math.min(t.length, r);

        for (var n = [], o = e; o < r;) {
          var i,
              s,
              a,
              c,
              u = t[o],
              h = null,
              f = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
          if (o + f <= r) switch (f) {
            case 1:
              u < 128 && (h = u);
              break;

            case 2:
              128 == (192 & (i = t[o + 1])) && (c = (31 & u) << 6 | 63 & i) > 127 && (h = c);
              break;

            case 3:
              i = t[o + 1], s = t[o + 2], 128 == (192 & i) && 128 == (192 & s) && (c = (15 & u) << 12 | (63 & i) << 6 | 63 & s) > 2047 && (c < 55296 || c > 57343) && (h = c);
              break;

            case 4:
              i = t[o + 1], s = t[o + 2], a = t[o + 3], 128 == (192 & i) && 128 == (192 & s) && 128 == (192 & a) && (c = (15 & u) << 18 | (63 & i) << 12 | (63 & s) << 6 | 63 & a) > 65535 && c < 1114112 && (h = c);
          }
          null === h ? (h = 65533, f = 1) : h > 65535 && (h -= 65536, n.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), n.push(h), o += f;
        }

        return function (t) {
          var e = t.length;
          if (e <= 4096) return String.fromCharCode.apply(String, t);
          var r = "",
              n = 0;

          for (; n < e;) {
            r += String.fromCharCode.apply(String, t.slice(n, n += 4096));
          }

          return r;
        }(n);
      }

      e.Buffer = c, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return c.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, c.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = s(), c.poolSize = 8192, c._augment = function (t) {
        return t.__proto__ = c.prototype, t;
      }, c.from = function (t, e, r) {
        return u(null, t, e, r);
      }, c.TYPED_ARRAY_SUPPORT && (c.prototype.__proto__ = Uint8Array.prototype, c.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && c[Symbol.species] === c && Object.defineProperty(c, Symbol.species, {
        value: null,
        configurable: !0
      })), c.alloc = function (t, e, r) {
        return function (t, e, r, n) {
          return h(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
        }(null, t, e, r);
      }, c.allocUnsafe = function (t) {
        return f(null, t);
      }, c.allocUnsafeSlow = function (t) {
        return f(null, t);
      }, c.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, c.compare = function (t, e) {
        if (!c.isBuffer(t) || !c.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var r = t.length, n = e.length, o = 0, i = Math.min(r, n); o < i; ++o) {
          if (t[o] !== e[o]) {
            r = t[o], n = e[o];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, c.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, c.concat = function (t, e) {
        if (!i(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return c.alloc(0);
        var r;
        if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
          e += t[r].length;
        }
        var n = c.allocUnsafe(e),
            o = 0;

        for (r = 0; r < t.length; ++r) {
          var s = t[r];
          if (!c.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
          s.copy(n, o), o += s.length;
        }

        return n;
      }, c.byteLength = d, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          g(this, e, e + 1);
        }

        return this;
      }, c.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          g(this, e, e + 3), g(this, e + 1, e + 2);
        }

        return this;
      }, c.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
        }

        return this;
      }, c.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? A(this, 0, t) : y.apply(this, arguments);
      }, c.prototype.equals = function (t) {
        if (!c.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === c.compare(this, t);
      }, c.prototype.inspect = function () {
        var t = "",
            r = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
      }, c.prototype.compare = function (t, e, r, n, o) {
        if (!c.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), e < 0 || r > t.length || n < 0 || o > this.length) throw new RangeError("out of range index");
        if (n >= o && e >= r) return 0;
        if (n >= o) return -1;
        if (e >= r) return 1;
        if (this === t) return 0;

        for (var i = (o >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), a = Math.min(i, s), u = this.slice(n, o), h = t.slice(e, r), f = 0; f < a; ++f) {
          if (u[f] !== h[f]) {
            i = u[f], s = h[f];
            break;
          }
        }

        return i < s ? -1 : s < i ? 1 : 0;
      }, c.prototype.includes = function (t, e, r) {
        return -1 !== this.indexOf(t, e, r);
      }, c.prototype.indexOf = function (t, e, r) {
        return v(this, t, e, r, !0);
      }, c.prototype.lastIndexOf = function (t, e, r) {
        return v(this, t, e, r, !1);
      }, c.prototype.write = function (t, e, r, n) {
        if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var o = this.length - e;
        if ((void 0 === r || r > o) && (r = o), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var i = !1;;) {
          switch (n) {
            case "hex":
              return b(this, t, e, r);

            case "utf8":
            case "utf-8":
              return w(this, t, e, r);

            case "ascii":
              return _(this, t, e, r);

            case "latin1":
            case "binary":
              return k(this, t, e, r);

            case "base64":
              return E(this, t, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return O(this, t, e, r);

            default:
              if (i) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), i = !0;
          }
        }
      }, c.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };

      function x(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var o = e; o < r; ++o) {
          n += String.fromCharCode(127 & t[o]);
        }

        return n;
      }

      function R(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var o = e; o < r; ++o) {
          n += String.fromCharCode(t[o]);
        }

        return n;
      }

      function P(t, e, r) {
        var n = t.length;
        (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

        for (var o = "", i = e; i < r; ++i) {
          o += D(t[i]);
        }

        return o;
      }

      function T(t, e, r) {
        for (var n = t.slice(e, r), o = "", i = 0; i < n.length; i += 2) {
          o += String.fromCharCode(n[i] + 256 * n[i + 1]);
        }

        return o;
      }

      function B(t, e, r) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function C(t, e, r, n, o, i) {
        if (!c.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
        if (r + n > t.length) throw new RangeError("Index out of range");
      }

      function L(t, e, r, n) {
        e < 0 && (e = 65535 + e + 1);

        for (var o = 0, i = Math.min(t.length - r, 2); o < i; ++o) {
          t[r + o] = (e & 255 << 8 * (n ? o : 1 - o)) >>> 8 * (n ? o : 1 - o);
        }
      }

      function j(t, e, r, n) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var o = 0, i = Math.min(t.length - r, 4); o < i; ++o) {
          t[r + o] = e >>> 8 * (n ? o : 3 - o) & 255;
        }
      }

      function N(t, e, r, n, o, i) {
        if (r + n > t.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function U(t, e, r, n, i) {
        return i || N(t, 0, r, 4), o.write(t, e, r, n, 23, 4), r + 4;
      }

      function M(t, e, r, n, i) {
        return i || N(t, 0, r, 8), o.write(t, e, r, n, 52, 8), r + 8;
      }

      c.prototype.slice = function (t, e) {
        var r,
            n = this.length;
        if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), c.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = c.prototype;else {
          var o = e - t;
          r = new c(o, void 0);

          for (var i = 0; i < o; ++i) {
            r[i] = this[i + t];
          }
        }
        return r;
      }, c.prototype.readUIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
          n += this[t + i] * o;
        }

        return n;
      }, c.prototype.readUIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = this[t + --e], o = 1; e > 0 && (o *= 256);) {
          n += this[t + --e] * o;
        }

        return n;
      }, c.prototype.readUInt8 = function (t, e) {
        return e || B(t, 1, this.length), this[t];
      }, c.prototype.readUInt16LE = function (t, e) {
        return e || B(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, c.prototype.readUInt16BE = function (t, e) {
        return e || B(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, c.prototype.readUInt32LE = function (t, e) {
        return e || B(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, c.prototype.readUInt32BE = function (t, e) {
        return e || B(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, c.prototype.readIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
          n += this[t + i] * o;
        }

        return n >= (o *= 128) && (n -= Math.pow(2, 8 * e)), n;
      }, c.prototype.readIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || B(t, e, this.length);

        for (var n = e, o = 1, i = this[t + --n]; n > 0 && (o *= 256);) {
          i += this[t + --n] * o;
        }

        return i >= (o *= 128) && (i -= Math.pow(2, 8 * e)), i;
      }, c.prototype.readInt8 = function (t, e) {
        return e || B(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, c.prototype.readInt16LE = function (t, e) {
        e || B(t, 2, this.length);
        var r = this[t] | this[t + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, c.prototype.readInt16BE = function (t, e) {
        e || B(t, 2, this.length);
        var r = this[t + 1] | this[t] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, c.prototype.readInt32LE = function (t, e) {
        return e || B(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, c.prototype.readInt32BE = function (t, e) {
        return e || B(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, c.prototype.readFloatLE = function (t, e) {
        return e || B(t, 4, this.length), o.read(this, t, !0, 23, 4);
      }, c.prototype.readFloatBE = function (t, e) {
        return e || B(t, 4, this.length), o.read(this, t, !1, 23, 4);
      }, c.prototype.readDoubleLE = function (t, e) {
        return e || B(t, 8, this.length), o.read(this, t, !0, 52, 8);
      }, c.prototype.readDoubleBE = function (t, e) {
        return e || B(t, 8, this.length), o.read(this, t, !1, 52, 8);
      }, c.prototype.writeUIntLE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || C(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var o = 1,
            i = 0;

        for (this[e] = 255 & t; ++i < r && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + r;
      }, c.prototype.writeUIntBE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || C(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var o = r - 1,
            i = 1;

        for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + r;
      }, c.prototype.writeUInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 1, 255, 0), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, c.prototype.writeUInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : L(this, t, e, !0), e + 2;
      }, c.prototype.writeUInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : L(this, t, e, !1), e + 2;
      }, c.prototype.writeUInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : j(this, t, e, !0), e + 4;
      }, c.prototype.writeUInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : j(this, t, e, !1), e + 4;
      }, c.prototype.writeIntLE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var o = Math.pow(2, 8 * r - 1);
          C(this, t, e, r, o - 1, -o);
        }

        var i = 0,
            s = 1,
            a = 0;

        for (this[e] = 255 & t; ++i < r && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + i - 1] && (a = 1), this[e + i] = (t / s >> 0) - a & 255;
        }

        return e + r;
      }, c.prototype.writeIntBE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var o = Math.pow(2, 8 * r - 1);
          C(this, t, e, r, o - 1, -o);
        }

        var i = r - 1,
            s = 1,
            a = 0;

        for (this[e + i] = 255 & t; --i >= 0 && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + i + 1] && (a = 1), this[e + i] = (t / s >> 0) - a & 255;
        }

        return e + r;
      }, c.prototype.writeInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 1, 127, -128), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, c.prototype.writeInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : L(this, t, e, !0), e + 2;
      }, c.prototype.writeInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : L(this, t, e, !1), e + 2;
      }, c.prototype.writeInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 4, 2147483647, -2147483648), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : j(this, t, e, !0), e + 4;
      }, c.prototype.writeInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || C(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : j(this, t, e, !1), e + 4;
      }, c.prototype.writeFloatLE = function (t, e, r) {
        return U(this, t, e, !0, r);
      }, c.prototype.writeFloatBE = function (t, e, r) {
        return U(this, t, e, !1, r);
      }, c.prototype.writeDoubleLE = function (t, e, r) {
        return M(this, t, e, !0, r);
      }, c.prototype.writeDoubleBE = function (t, e, r) {
        return M(this, t, e, !1, r);
      }, c.prototype.copy = function (t, e, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
        var o,
            i = n - r;
        if (this === t && r < e && e < n) for (o = i - 1; o >= 0; --o) {
          t[o + e] = this[o + r];
        } else if (i < 1e3 || !c.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
          t[o + e] = this[o + r];
        } else Uint8Array.prototype.set.call(t, this.subarray(r, r + i), e);
        return i;
      }, c.prototype.fill = function (t, e, r, n) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
            var o = t.charCodeAt(0);
            o < 256 && (t = o);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !c.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
        if (r <= e) return this;
        var i;
        if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (i = e; i < r; ++i) {
          this[i] = t;
        } else {
          var s = c.isBuffer(t) ? t : Y(new c(t, n).toString()),
              a = s.length;

          for (i = 0; i < r - e; ++i) {
            this[i + e] = s[i % a];
          }
        }
        return this;
      };
      var I = /[^+\/0-9A-Za-z-_]/g;

      function D(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function Y(t, e) {
        var r;
        e = e || 1 / 0;

        for (var n = t.length, o = null, i = [], s = 0; s < n; ++s) {
          if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
            if (!o) {
              if (r > 56319) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              if (s + 1 === n) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              o = r;
              continue;
            }

            if (r < 56320) {
              (e -= 3) > -1 && i.push(239, 191, 189), o = r;
              continue;
            }

            r = 65536 + (o - 55296 << 10 | r - 56320);
          } else o && (e -= 3) > -1 && i.push(239, 191, 189);

          if (o = null, r < 128) {
            if ((e -= 1) < 0) break;
            i.push(r);
          } else if (r < 2048) {
            if ((e -= 2) < 0) break;
            i.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((e -= 3) < 0) break;
            i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return i;
      }

      function q(t) {
        return n.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
          }(t).replace(I, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function F(t, e, r, n) {
        for (var o = 0; o < n && !(o + r >= e.length || o >= t.length); ++o) {
          e[o + r] = t[o];
        }

        return o;
      }
    }).call(this, r(13));
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    e.byteLength = function (t) {
      var e = u(t),
          r = e[0],
          n = e[1];
      return 3 * (r + n) / 4 - n;
    }, e.toByteArray = function (t) {
      var e,
          r,
          n = u(t),
          s = n[0],
          a = n[1],
          c = new i(function (t, e, r) {
        return 3 * (e + r) / 4 - r;
      }(0, s, a)),
          h = 0,
          f = a > 0 ? s - 4 : s;

      for (r = 0; r < f; r += 4) {
        e = o[t.charCodeAt(r)] << 18 | o[t.charCodeAt(r + 1)] << 12 | o[t.charCodeAt(r + 2)] << 6 | o[t.charCodeAt(r + 3)], c[h++] = e >> 16 & 255, c[h++] = e >> 8 & 255, c[h++] = 255 & e;
      }

      2 === a && (e = o[t.charCodeAt(r)] << 2 | o[t.charCodeAt(r + 1)] >> 4, c[h++] = 255 & e);
      1 === a && (e = o[t.charCodeAt(r)] << 10 | o[t.charCodeAt(r + 1)] << 4 | o[t.charCodeAt(r + 2)] >> 2, c[h++] = e >> 8 & 255, c[h++] = 255 & e);
      return c;
    }, e.fromByteArray = function (t) {
      for (var e, r = t.length, o = r % 3, i = [], s = 0, a = r - o; s < a; s += 16383) {
        i.push(h(t, s, s + 16383 > a ? a : s + 16383));
      }

      1 === o ? (e = t[r - 1], i.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === o && (e = (t[r - 2] << 8) + t[r - 1], i.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
      return i.join("");
    };

    for (var n = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, c = s.length; a < c; ++a) {
      n[a] = s[a], o[s.charCodeAt(a)] = a;
    }

    function u(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }

    function h(t, e, r) {
      for (var o, i, s = [], a = e; a < r; a += 3) {
        o = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), s.push(n[(i = o) >> 18 & 63] + n[i >> 12 & 63] + n[i >> 6 & 63] + n[63 & i]);
      }

      return s.join("");
    }

    o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
    e.read = function (t, e, r, n, o) {
      var i,
          s,
          a = 8 * o - n - 1,
          c = (1 << a) - 1,
          u = c >> 1,
          h = -7,
          f = r ? o - 1 : 0,
          l = r ? -1 : 1,
          p = t[e + f];

      for (f += l, i = p & (1 << -h) - 1, p >>= -h, h += a; h > 0; i = 256 * i + t[e + f], f += l, h -= 8) {
        ;
      }

      for (s = i & (1 << -h) - 1, i >>= -h, h += n; h > 0; s = 256 * s + t[e + f], f += l, h -= 8) {
        ;
      }

      if (0 === i) i = 1 - u;else {
        if (i === c) return s ? NaN : 1 / 0 * (p ? -1 : 1);
        s += Math.pow(2, n), i -= u;
      }
      return (p ? -1 : 1) * s * Math.pow(2, i - n);
    }, e.write = function (t, e, r, n, o, i) {
      var s,
          a,
          c,
          u = 8 * i - o - 1,
          h = (1 << u) - 1,
          f = h >> 1,
          l = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          p = n ? 0 : i - 1,
          d = n ? 1 : -1,
          y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -s)) < 1 && (s--, c *= 2), (e += s + f >= 1 ? l / c : l * Math.pow(2, 1 - f)) * c >= 2 && (s++, c /= 2), s + f >= h ? (a = 0, s = h) : s + f >= 1 ? (a = (e * c - 1) * Math.pow(2, o), s += f) : (a = e * Math.pow(2, f - 1) * Math.pow(2, o), s = 0)); o >= 8; t[r + p] = 255 & a, p += d, a /= 256, o -= 8) {
        ;
      }

      for (s = s << o | a, u += o; u > 0; t[r + p] = 255 & s, p += d, s /= 256, u -= 8) {
        ;
      }

      t[r + p - d] |= 128 * y;
    };
  }, function (t, e) {
    var r = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == r.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = window.URL || window.webkitURL;

    t.exports = function (t) {
      try {
        var e;

        try {
          (e = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)()).append(t), e = e.getBlob("application/javascript; charset=utf-8");
        } catch (r) {
          e = new Blob([t], {
            type: "application/javascript; charset=utf-8"
          });
        }

        return n.createObjectURL(e);
      } catch (e) {
        return "data:application/javascript," + encodeURIComponent(t);
      }
    };
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var n = {};
    r.r(n), r.d(n, "protocol", function () {
      return C;
    }), r.d(n, "PacketType", function () {
      return L;
    }), r.d(n, "Encoder", function () {
      return j;
    }), r.d(n, "Decoder", function () {
      return N;
    });
    var o = r(5),
        i = r(7),
        s = r(6),
        a = r(4);
    var c = !1;

    try {
      c = "undefined" != typeof XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
    } catch (t) {}

    var u = c;
    var h = r(0);

    function f(t) {
      var e = t.xdomain;

      try {
        if ("undefined" != typeof XMLHttpRequest && (!e || u)) return new XMLHttpRequest();
      } catch (t) {}

      if (!e) try {
        return new h.a[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
      } catch (t) {}
    }

    var l = r(1),
        p = r(2);

    function d() {}

    var y = null != new f({
      xdomain: !1
    }).responseType;

    var g = /*#__PURE__*/function (_o$a2) {
      _inherits(g, _o$a2);

      var _super4 = _createSuper(g);

      function g(t) {
        var _this6;

        _classCallCheck(this, g);

        if (_this6 = _super4.call(this, t), _this6.polling = !1, "undefined" != typeof location) {
          var _e = "https:" === location.protocol;

          var _r4 = location.port;
          _r4 || (_r4 = _e ? "443" : "80"), _this6.xd = "undefined" != typeof location && t.hostname !== location.hostname || _r4 !== t.port, _this6.xs = t.secure !== _e;
        }

        var e = t && t.forceBase64;
        _this6.supportsBinary = y && !e;
        return _possibleConstructorReturn(_this6);
      }

      _createClass(g, [{
        key: "name",
        get: function get() {
          return "polling";
        }
      }, {
        key: "doOpen",
        value: function doOpen() {
          this.poll();
        }
      }, {
        key: "pause",
        value: function pause(t) {
          var _this7 = this;

          this.readyState = "pausing";

          var e = function e() {
            _this7.readyState = "paused", t();
          };

          if (this.polling || !this.writable) {
            var _t5 = 0;
            this.polling && (_t5++, this.once("pollComplete", function () {
              --_t5 || e();
            })), this.writable || (_t5++, this.once("drain", function () {
              --_t5 || e();
            }));
          } else e();
        }
      }, {
        key: "poll",
        value: function poll() {
          this.polling = !0, this.doPoll(), this.emitReserved("poll");
        }
      }, {
        key: "onData",
        value: function onData(t) {
          var _this8 = this;

          Object(a.b)(t, this.socket.binaryType).forEach(function (t) {
            if ("opening" === _this8.readyState && "open" === t.type && _this8.onOpen(), "close" === t.type) return _this8.onClose({
              description: "transport closed by the server"
            }), !1;

            _this8.onPacket(t);
          }), "closed" !== this.readyState && (this.polling = !1, this.emitReserved("pollComplete"), "open" === this.readyState && this.poll());
        }
      }, {
        key: "doClose",
        value: function doClose() {
          var _this9 = this;

          var t = function t() {
            _this9.write([{
              type: "close"
            }]);
          };

          "open" === this.readyState ? t() : this.once("open", t);
        }
      }, {
        key: "write",
        value: function write(t) {
          var _this10 = this;

          this.writable = !1, Object(a.d)(t, function (t) {
            _this10.doWrite(t, function () {
              _this10.writable = !0, _this10.emitReserved("drain");
            });
          });
        }
      }, {
        key: "uri",
        value: function uri() {
          var t = this.query || {};
          var e = this.opts.secure ? "https" : "http";
          var r = "";
          !1 !== this.opts.timestampRequests && (t[this.opts.timestampParam] = Object(i.a)()), this.supportsBinary || t.sid || (t.b64 = 1), this.opts.port && ("https" === e && 443 !== Number(this.opts.port) || "http" === e && 80 !== Number(this.opts.port)) && (r = ":" + this.opts.port);
          var n = Object(s.b)(t);
          return e + "://" + (-1 !== this.opts.hostname.indexOf(":") ? "[" + this.opts.hostname + "]" : this.opts.hostname) + r + this.opts.path + (n.length ? "?" + n : "");
        }
      }, {
        key: "request",
        value: function request() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return Object.assign(t, {
            xd: this.xd,
            xs: this.xs
          }, this.opts), new v(this.uri(), t);
        }
      }, {
        key: "doWrite",
        value: function doWrite(t, e) {
          var _this11 = this;

          var r = this.request({
            method: "POST",
            data: t
          });
          r.on("success", e), r.on("error", function (t, e) {
            _this11.onError("xhr post error", t, e);
          });
        }
      }, {
        key: "doPoll",
        value: function doPoll() {
          var _this12 = this;

          var t = this.request();
          t.on("data", this.onData.bind(this)), t.on("error", function (t, e) {
            _this12.onError("xhr poll error", t, e);
          }), this.pollXhr = t;
        }
      }]);

      return g;
    }(o.a);

    var v = /*#__PURE__*/function (_l$a) {
      _inherits(v, _l$a);

      var _super5 = _createSuper(v);

      function v(t, e) {
        var _this13;

        _classCallCheck(this, v);

        _this13 = _super5.call(this), Object(p.b)(_assertThisInitialized(_this13), e), _this13.opts = e, _this13.method = e.method || "GET", _this13.uri = t, _this13.async = !1 !== e.async, _this13.data = void 0 !== e.data ? e.data : null, _this13.create();
        return _this13;
      }

      _createClass(v, [{
        key: "create",
        value: function create() {
          var _this14 = this;

          var t = Object(p.c)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
          t.xdomain = !!this.opts.xd, t.xscheme = !!this.opts.xs;
          var e = this.xhr = new f(t);

          try {
            e.open(this.method, this.uri, this.async);

            try {
              if (this.opts.extraHeaders) {
                e.setDisableHeaderCheck && e.setDisableHeaderCheck(!0);

                for (var _t6 in this.opts.extraHeaders) {
                  this.opts.extraHeaders.hasOwnProperty(_t6) && e.setRequestHeader(_t6, this.opts.extraHeaders[_t6]);
                }
              }
            } catch (t) {}

            if ("POST" === this.method) try {
              e.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (t) {}

            try {
              e.setRequestHeader("Accept", "*/*");
            } catch (t) {}

            "withCredentials" in e && (e.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (e.timeout = this.opts.requestTimeout), e.onreadystatechange = function () {
              4 === e.readyState && (200 === e.status || 1223 === e.status ? _this14.onLoad() : _this14.setTimeoutFn(function () {
                _this14.onError("number" == typeof e.status ? e.status : 0);
              }, 0));
            }, e.send(this.data);
          } catch (t) {
            return void this.setTimeoutFn(function () {
              _this14.onError(t);
            }, 0);
          }

          "undefined" != typeof document && (this.index = v.requestsCount++, v.requests[this.index] = this);
        }
      }, {
        key: "onError",
        value: function onError(t) {
          this.emitReserved("error", t, this.xhr), this.cleanup(!0);
        }
      }, {
        key: "cleanup",
        value: function cleanup(t) {
          if (void 0 !== this.xhr && null !== this.xhr) {
            if (this.xhr.onreadystatechange = d, t) try {
              this.xhr.abort();
            } catch (t) {}
            "undefined" != typeof document && delete v.requests[this.index], this.xhr = null;
          }
        }
      }, {
        key: "onLoad",
        value: function onLoad() {
          var t = this.xhr.responseText;
          null !== t && (this.emitReserved("data", t), this.emitReserved("success"), this.cleanup());
        }
      }, {
        key: "abort",
        value: function abort() {
          this.cleanup();
        }
      }]);

      return v;
    }(l.a);

    if (v.requestsCount = 0, v.requests = {}, "undefined" != typeof document) if ("function" == typeof attachEvent) attachEvent("onunload", m);else if ("function" == typeof addEventListener) {
      var _t7 = "onpagehide" in h.a ? "pagehide" : "unload";

      addEventListener(_t7, m, !1);
    }

    function m() {
      for (var _t8 in v.requests) {
        v.requests.hasOwnProperty(_t8) && v.requests[_t8].abort();
      }
    }

    var b = {
      websocket: r(8).a,
      polling: g
    },
        w = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
        _ = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];

    function k(t) {
      var e = t,
          r = t.indexOf("["),
          n = t.indexOf("]");
      -1 != r && -1 != n && (t = t.substring(0, r) + t.substring(r, n).replace(/:/g, ";") + t.substring(n, t.length));
      var o = w.exec(t || ""),
          i = {},
          s = 14;

      for (; s--;) {
        i[_[s]] = o[s] || "";
      }

      return -1 != r && -1 != n && (i.source = e, i.host = i.host.substring(1, i.host.length - 1).replace(/;/g, ":"), i.authority = i.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), i.ipv6uri = !0), i.pathNames = function (t, e) {
        var r = e.replace(/\/{2,9}/g, "/").split("/");
        "/" != e.slice(0, 1) && 0 !== e.length || r.splice(0, 1);
        "/" == e.slice(-1) && r.splice(r.length - 1, 1);
        return r;
      }(0, i.path), i.queryKey = function (t, e) {
        var r = {};
        return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function (t, e, n) {
          e && (r[e] = n);
        }), r;
      }(0, i.query), i;
    }

    var E = /*#__PURE__*/function (_l$a2) {
      _inherits(E, _l$a2);

      var _super6 = _createSuper(E);

      function E(t) {
        var _this15;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, E);

        _this15 = _super6.call(this), _this15.writeBuffer = [], t && "object" == _typeof(t) && (e = t, t = null), t ? (t = k(t), e.hostname = t.host, e.secure = "https" === t.protocol || "wss" === t.protocol, e.port = t.port, t.query && (e.query = t.query)) : e.host && (e.hostname = k(e.host).host), Object(p.b)(_assertThisInitialized(_this15), e), _this15.secure = null != e.secure ? e.secure : "undefined" != typeof location && "https:" === location.protocol, e.hostname && !e.port && (e.port = _this15.secure ? "443" : "80"), _this15.hostname = e.hostname || ("undefined" != typeof location ? location.hostname : "localhost"), _this15.port = e.port || ("undefined" != typeof location && location.port ? location.port : _this15.secure ? "443" : "80"), _this15.transports = e.transports || ["polling", "websocket"], _this15.writeBuffer = [], _this15.prevBufferLen = 0, _this15.opts = Object.assign({
          path: "/engine.io",
          agent: !1,
          withCredentials: !1,
          upgrade: !0,
          timestampParam: "t",
          rememberUpgrade: !1,
          addTrailingSlash: !0,
          rejectUnauthorized: !0,
          perMessageDeflate: {
            threshold: 1024
          },
          transportOptions: {},
          closeOnBeforeunload: !0
        }, e), _this15.opts.path = _this15.opts.path.replace(/\/$/, "") + (_this15.opts.addTrailingSlash ? "/" : ""), "string" == typeof _this15.opts.query && (_this15.opts.query = Object(s.a)(_this15.opts.query)), _this15.id = null, _this15.upgrades = null, _this15.pingInterval = null, _this15.pingTimeout = null, _this15.pingTimeoutTimer = null, "function" == typeof addEventListener && (_this15.opts.closeOnBeforeunload && (_this15.beforeunloadEventListener = function () {
          _this15.transport && (_this15.transport.removeAllListeners(), _this15.transport.close());
        }, addEventListener("beforeunload", _this15.beforeunloadEventListener, !1)), "localhost" !== _this15.hostname && (_this15.offlineEventListener = function () {
          _this15.onClose("transport close", {
            description: "network connection lost"
          });
        }, addEventListener("offline", _this15.offlineEventListener, !1))), _this15.open();
        return _this15;
      }

      _createClass(E, [{
        key: "createTransport",
        value: function createTransport(t) {
          var e = Object.assign({}, this.opts.query);
          e.EIO = a.e, e.transport = t, this.id && (e.sid = this.id);
          var r = Object.assign({}, this.opts.transportOptions[t], this.opts, {
            query: e,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
          });
          return new b[t](r);
        }
      }, {
        key: "open",
        value: function open() {
          var _this16 = this;

          var t;
          if (this.opts.rememberUpgrade && E.priorWebsocketSuccess && -1 !== this.transports.indexOf("websocket")) t = "websocket";else {
            if (0 === this.transports.length) return void this.setTimeoutFn(function () {
              _this16.emitReserved("error", "No transports available");
            }, 0);
            t = this.transports[0];
          }
          this.readyState = "opening";

          try {
            t = this.createTransport(t);
          } catch (t) {
            return this.transports.shift(), void this.open();
          }

          t.open(), this.setTransport(t);
        }
      }, {
        key: "setTransport",
        value: function setTransport(t) {
          var _this17 = this;

          this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", function (t) {
            return _this17.onClose("transport close", t);
          });
        }
      }, {
        key: "probe",
        value: function probe(t) {
          var _this18 = this;

          var e = this.createTransport(t),
              r = !1;
          E.priorWebsocketSuccess = !1;

          var n = function n() {
            r || (e.send([{
              type: "ping",
              data: "probe"
            }]), e.once("packet", function (t) {
              if (!r) if ("pong" === t.type && "probe" === t.data) {
                if (_this18.upgrading = !0, _this18.emitReserved("upgrading", e), !e) return;
                E.priorWebsocketSuccess = "websocket" === e.name, _this18.transport.pause(function () {
                  r || "closed" !== _this18.readyState && (u(), _this18.setTransport(e), e.send([{
                    type: "upgrade"
                  }]), _this18.emitReserved("upgrade", e), e = null, _this18.upgrading = !1, _this18.flush());
                });
              } else {
                var _t9 = new Error("probe error");

                _t9.transport = e.name, _this18.emitReserved("upgradeError", _t9);
              }
            }));
          };

          function o() {
            r || (r = !0, u(), e.close(), e = null);
          }

          var i = function i(t) {
            var r = new Error("probe error: " + t);
            r.transport = e.name, o(), _this18.emitReserved("upgradeError", r);
          };

          function s() {
            i("transport closed");
          }

          function a() {
            i("socket closed");
          }

          function c(t) {
            e && t.name !== e.name && o();
          }

          var u = function u() {
            e.removeListener("open", n), e.removeListener("error", i), e.removeListener("close", s), _this18.off("close", a), _this18.off("upgrading", c);
          };

          e.once("open", n), e.once("error", i), e.once("close", s), this.once("close", a), this.once("upgrading", c), e.open();
        }
      }, {
        key: "onOpen",
        value: function onOpen() {
          if (this.readyState = "open", E.priorWebsocketSuccess = "websocket" === this.transport.name, this.emitReserved("open"), this.flush(), "open" === this.readyState && this.opts.upgrade) {
            var _t10 = 0;
            var _e2 = this.upgrades.length;

            for (; _t10 < _e2; _t10++) {
              this.probe(this.upgrades[_t10]);
            }
          }
        }
      }, {
        key: "onPacket",
        value: function onPacket(t) {
          if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), t.type) {
            case "open":
              this.onHandshake(JSON.parse(t.data));
              break;

            case "ping":
              this.resetPingTimeout(), this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
              break;

            case "error":
              var _e3 = new Error("server error");

              _e3.code = t.data, this.onError(_e3);
              break;

            case "message":
              this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          }
        }
      }, {
        key: "onHandshake",
        value: function onHandshake(t) {
          this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this.upgrades = this.filterUpgrades(t.upgrades), this.pingInterval = t.pingInterval, this.pingTimeout = t.pingTimeout, this.maxPayload = t.maxPayload, this.onOpen(), "closed" !== this.readyState && this.resetPingTimeout();
        }
      }, {
        key: "resetPingTimeout",
        value: function resetPingTimeout() {
          var _this19 = this;

          this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(function () {
            _this19.onClose("ping timeout");
          }, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
        }
      }, {
        key: "onDrain",
        value: function onDrain() {
          this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, 0 === this.writeBuffer.length ? this.emitReserved("drain") : this.flush();
        }
      }, {
        key: "flush",
        value: function flush() {
          if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            var _t11 = this.getWritablePackets();

            this.transport.send(_t11), this.prevBufferLen = _t11.length, this.emitReserved("flush");
          }
        }
      }, {
        key: "getWritablePackets",
        value: function getWritablePackets() {
          if (!(this.maxPayload && "polling" === this.transport.name && this.writeBuffer.length > 1)) return this.writeBuffer;
          var t = 1;

          for (var _e4 = 0; _e4 < this.writeBuffer.length; _e4++) {
            var _r5 = this.writeBuffer[_e4].data;
            if (_r5 && (t += Object(p.a)(_r5)), _e4 > 0 && t > this.maxPayload) return this.writeBuffer.slice(0, _e4);
            t += 2;
          }

          return this.writeBuffer;
        }
      }, {
        key: "write",
        value: function write(t, e, r) {
          return this.sendPacket("message", t, e, r), this;
        }
      }, {
        key: "send",
        value: function send(t, e, r) {
          return this.sendPacket("message", t, e, r), this;
        }
      }, {
        key: "sendPacket",
        value: function sendPacket(t, e, r, n) {
          if ("function" == typeof e && (n = e, e = void 0), "function" == typeof r && (n = r, r = null), "closing" === this.readyState || "closed" === this.readyState) return;
          (r = r || {}).compress = !1 !== r.compress;
          var o = {
            type: t,
            data: e,
            options: r
          };
          this.emitReserved("packetCreate", o), this.writeBuffer.push(o), n && this.once("flush", n), this.flush();
        }
      }, {
        key: "close",
        value: function close() {
          var _this20 = this;

          var t = function t() {
            _this20.onClose("forced close"), _this20.transport.close();
          },
              e = function e() {
            _this20.off("upgrade", e), _this20.off("upgradeError", e), t();
          },
              r = function r() {
            _this20.once("upgrade", e), _this20.once("upgradeError", e);
          };

          return "opening" !== this.readyState && "open" !== this.readyState || (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", function () {
            _this20.upgrading ? r() : t();
          }) : this.upgrading ? r() : t()), this;
        }
      }, {
        key: "onError",
        value: function onError(t) {
          E.priorWebsocketSuccess = !1, this.emitReserved("error", t), this.onClose("transport error", t);
        }
      }, {
        key: "onClose",
        value: function onClose(t, e) {
          "opening" !== this.readyState && "open" !== this.readyState && "closing" !== this.readyState || (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), "function" == typeof removeEventListener && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", t, e), this.writeBuffer = [], this.prevBufferLen = 0);
        }
      }, {
        key: "filterUpgrades",
        value: function filterUpgrades(t) {
          var e = [];
          var r = 0;
          var n = t.length;

          for (; r < n; r++) {
            ~this.transports.indexOf(t[r]) && e.push(t[r]);
          }

          return e;
        }
      }]);

      return E;
    }(l.a);

    E.protocol = a.e;
    var O = r(3);
    E.protocol;
    var S = "function" == typeof ArrayBuffer,
        A = Object.prototype.toString,
        x = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === A.call(Blob),
        R = "function" == typeof File || "undefined" != typeof File && "[object FileConstructor]" === A.call(File);

    function P(t) {
      return S && (t instanceof ArrayBuffer || function (t) {
        return "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : t.buffer instanceof ArrayBuffer;
      }(t)) || x && t instanceof Blob || R && t instanceof File;
    }

    function T(t) {
      var e = [],
          r = t.data,
          n = t;
      return n.data = function t(e, r) {
        if (!e) return e;

        if (P(e)) {
          var _t12 = {
            _placeholder: !0,
            num: r.length
          };
          return r.push(e), _t12;
        }

        if (Array.isArray(e)) {
          var _n4 = new Array(e.length);

          for (var _o3 = 0; _o3 < e.length; _o3++) {
            _n4[_o3] = t(e[_o3], r);
          }

          return _n4;
        }

        if ("object" == _typeof(e) && !(e instanceof Date)) {
          var _n5 = {};

          for (var _o4 in e) {
            Object.prototype.hasOwnProperty.call(e, _o4) && (_n5[_o4] = t(e[_o4], r));
          }

          return _n5;
        }

        return e;
      }(r, e), n.attachments = e.length, {
        packet: n,
        buffers: e
      };
    }

    function B(t, e) {
      return t.data = function t(e, r) {
        if (!e) return e;

        if (e && !0 === e._placeholder) {
          if ("number" == typeof e.num && e.num >= 0 && e.num < r.length) return r[e.num];
          throw new Error("illegal attachments");
        }

        if (Array.isArray(e)) for (var _n6 = 0; _n6 < e.length; _n6++) {
          e[_n6] = t(e[_n6], r);
        } else if ("object" == _typeof(e)) for (var _n7 in e) {
          Object.prototype.hasOwnProperty.call(e, _n7) && (e[_n7] = t(e[_n7], r));
        }
        return e;
      }(t.data, e), t.attachments = void 0, t;
    }

    var C = 5;
    var L;
    !function (t) {
      t[t.CONNECT = 0] = "CONNECT", t[t.DISCONNECT = 1] = "DISCONNECT", t[t.EVENT = 2] = "EVENT", t[t.ACK = 3] = "ACK", t[t.CONNECT_ERROR = 4] = "CONNECT_ERROR", t[t.BINARY_EVENT = 5] = "BINARY_EVENT", t[t.BINARY_ACK = 6] = "BINARY_ACK";
    }(L || (L = {}));

    var j = /*#__PURE__*/function () {
      function j(t) {
        _classCallCheck(this, j);

        this.replacer = t;
      }

      _createClass(j, [{
        key: "encode",
        value: function encode(t) {
          return t.type !== L.EVENT && t.type !== L.ACK || !function t(e, r) {
            if (!e || "object" != _typeof(e)) return !1;

            if (Array.isArray(e)) {
              for (var _r6 = 0, _n8 = e.length; _r6 < _n8; _r6++) {
                if (t(e[_r6])) return !0;
              }

              return !1;
            }

            if (P(e)) return !0;
            if (e.toJSON && "function" == typeof e.toJSON && 1 === arguments.length) return t(e.toJSON(), !0);

            for (var _r7 in e) {
              if (Object.prototype.hasOwnProperty.call(e, _r7) && t(e[_r7])) return !0;
            }

            return !1;
          }(t) ? [this.encodeAsString(t)] : (t.type = t.type === L.EVENT ? L.BINARY_EVENT : L.BINARY_ACK, this.encodeAsBinary(t));
        }
      }, {
        key: "encodeAsString",
        value: function encodeAsString(t) {
          var e = "" + t.type;
          return t.type !== L.BINARY_EVENT && t.type !== L.BINARY_ACK || (e += t.attachments + "-"), t.nsp && "/" !== t.nsp && (e += t.nsp + ","), null != t.id && (e += t.id), null != t.data && (e += JSON.stringify(t.data, this.replacer)), e;
        }
      }, {
        key: "encodeAsBinary",
        value: function encodeAsBinary(t) {
          var e = T(t),
              r = this.encodeAsString(e.packet),
              n = e.buffers;
          return n.unshift(r), n;
        }
      }]);

      return j;
    }();

    var N = /*#__PURE__*/function (_l$a3) {
      _inherits(N, _l$a3);

      var _super7 = _createSuper(N);

      function N(t) {
        var _this21;

        _classCallCheck(this, N);

        _this21 = _super7.call(this), _this21.reviver = t;
        return _this21;
      }

      _createClass(N, [{
        key: "add",
        value: function add(t) {
          var e;

          if ("string" == typeof t) {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            e = this.decodeString(t), e.type === L.BINARY_EVENT || e.type === L.BINARY_ACK ? (this.reconstructor = new U(e), 0 === e.attachments && _get(_getPrototypeOf(N.prototype), "emitReserved", this).call(this, "decoded", e)) : _get(_getPrototypeOf(N.prototype), "emitReserved", this).call(this, "decoded", e);
          } else {
            if (!P(t) && !t.base64) throw new Error("Unknown type: " + t);
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            e = this.reconstructor.takeBinaryData(t), e && (this.reconstructor = null, _get(_getPrototypeOf(N.prototype), "emitReserved", this).call(this, "decoded", e));
          }
        }
      }, {
        key: "decodeString",
        value: function decodeString(t) {
          var e = 0;
          var r = {
            type: Number(t.charAt(0))
          };
          if (void 0 === L[r.type]) throw new Error("unknown packet type " + r.type);

          if (r.type === L.BINARY_EVENT || r.type === L.BINARY_ACK) {
            var _n9 = e + 1;

            for (; "-" !== t.charAt(++e) && e != t.length;) {
              ;
            }

            var _o5 = t.substring(_n9, e);

            if (_o5 != Number(_o5) || "-" !== t.charAt(e)) throw new Error("Illegal attachments");
            r.attachments = Number(_o5);
          }

          if ("/" === t.charAt(e + 1)) {
            var _n10 = e + 1;

            for (; ++e;) {
              if ("," === t.charAt(e)) break;
              if (e === t.length) break;
            }

            r.nsp = t.substring(_n10, e);
          } else r.nsp = "/";

          var n = t.charAt(e + 1);

          if ("" !== n && Number(n) == n) {
            var _n11 = e + 1;

            for (; ++e;) {
              var _r8 = t.charAt(e);

              if (null == _r8 || Number(_r8) != _r8) {
                --e;
                break;
              }

              if (e === t.length) break;
            }

            r.id = Number(t.substring(_n11, e + 1));
          }

          if (t.charAt(++e)) {
            var _n12 = this.tryParse(t.substr(e));

            if (!N.isPayloadValid(r.type, _n12)) throw new Error("invalid payload");
            r.data = _n12;
          }

          return r;
        }
      }, {
        key: "tryParse",
        value: function tryParse(t) {
          try {
            return JSON.parse(t, this.reviver);
          } catch (t) {
            return !1;
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.reconstructor && this.reconstructor.finishedReconstruction();
        }
      }], [{
        key: "isPayloadValid",
        value: function isPayloadValid(t, e) {
          switch (t) {
            case L.CONNECT:
              return "object" == _typeof(e);

            case L.DISCONNECT:
              return void 0 === e;

            case L.CONNECT_ERROR:
              return "string" == typeof e || "object" == _typeof(e);

            case L.EVENT:
            case L.BINARY_EVENT:
              return Array.isArray(e) && e.length > 0;

            case L.ACK:
            case L.BINARY_ACK:
              return Array.isArray(e);
          }
        }
      }]);

      return N;
    }(l.a);

    var U = /*#__PURE__*/function () {
      function U(t) {
        _classCallCheck(this, U);

        this.packet = t, this.buffers = [], this.reconPack = t;
      }

      _createClass(U, [{
        key: "takeBinaryData",
        value: function takeBinaryData(t) {
          if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
            var _t13 = B(this.reconPack, this.buffers);

            return this.finishedReconstruction(), _t13;
          }

          return null;
        }
      }, {
        key: "finishedReconstruction",
        value: function finishedReconstruction() {
          this.reconPack = null, this.buffers = [];
        }
      }]);

      return U;
    }();

    function M(t, e, r) {
      return t.on(e, r), function () {
        t.off(e, r);
      };
    }

    var I = Object.freeze({
      connect: 1,
      connect_error: 1,
      disconnect: 1,
      disconnecting: 1,
      newListener: 1,
      removeListener: 1
    });

    var D = /*#__PURE__*/function (_l$a4) {
      _inherits(D, _l$a4);

      var _super8 = _createSuper(D);

      function D(t, e, r) {
        var _this22;

        _classCallCheck(this, D);

        _this22 = _super8.call(this), _this22.connected = !1, _this22.recovered = !1, _this22.receiveBuffer = [], _this22.sendBuffer = [], _this22._queue = [], _this22.ids = 0, _this22.acks = {}, _this22.flags = {}, _this22.io = t, _this22.nsp = e, r && r.auth && (_this22.auth = r.auth), _this22._opts = Object.assign({}, r), _this22.io._autoConnect && _this22.open();
        return _this22;
      }

      _createClass(D, [{
        key: "disconnected",
        get: function get() {
          return !this.connected;
        }
      }, {
        key: "subEvents",
        value: function subEvents() {
          if (this.subs) return;
          var t = this.io;
          this.subs = [M(t, "open", this.onopen.bind(this)), M(t, "packet", this.onpacket.bind(this)), M(t, "error", this.onerror.bind(this)), M(t, "close", this.onclose.bind(this))];
        }
      }, {
        key: "active",
        get: function get() {
          return !!this.subs;
        }
      }, {
        key: "connect",
        value: function connect() {
          return this.connected || (this.subEvents(), this.io._reconnecting || this.io.open(), "open" === this.io._readyState && this.onopen()), this;
        }
      }, {
        key: "open",
        value: function open() {
          return this.connect();
        }
      }, {
        key: "send",
        value: function send() {
          for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            t[_key2] = arguments[_key2];
          }

          return t.unshift("message"), this.emit.apply(this, t), this;
        }
      }, {
        key: "emit",
        value: function emit(t) {
          if (I.hasOwnProperty(t)) throw new Error('"' + t.toString() + '" is a reserved event name');

          for (var _len3 = arguments.length, e = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            e[_key3 - 1] = arguments[_key3];
          }

          if (e.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(e), this;
          var r = {
            type: L.EVENT,
            data: e,
            options: {}
          };

          if (r.options.compress = !1 !== this.flags.compress, "function" == typeof e[e.length - 1]) {
            var _t14 = this.ids++,
                _n13 = e.pop();

            this._registerAckCallback(_t14, _n13), r.id = _t14;
          }

          var n = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
          return this.flags.volatile && (!n || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(r), this.packet(r)) : this.sendBuffer.push(r)), this.flags = {}, this;
        }
      }, {
        key: "_registerAckCallback",
        value: function _registerAckCallback(t, e) {
          var _this23 = this;

          var r;
          var n = null !== (r = this.flags.timeout) && void 0 !== r ? r : this._opts.ackTimeout;
          if (void 0 === n) return void (this.acks[t] = e);
          var o = this.io.setTimeoutFn(function () {
            delete _this23.acks[t];

            for (var _e5 = 0; _e5 < _this23.sendBuffer.length; _e5++) {
              _this23.sendBuffer[_e5].id === t && _this23.sendBuffer.splice(_e5, 1);
            }

            e.call(_this23, new Error("operation has timed out"));
          }, n);

          this.acks[t] = function () {
            for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              t[_key4] = arguments[_key4];
            }

            _this23.io.clearTimeoutFn(o), e.apply(_this23, [null].concat(t));
          };
        }
      }, {
        key: "emitWithAck",
        value: function emitWithAck(t) {
          var _this24 = this;

          for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
            e[_key5 - 1] = arguments[_key5];
          }

          var r = void 0 !== this.flags.timeout || void 0 !== this._opts.ackTimeout;
          return new Promise(function (n, o) {
            e.push(function (t, e) {
              return r ? t ? o(t) : n(e) : n(t);
            }), _this24.emit.apply(_this24, [t].concat(e));
          });
        }
      }, {
        key: "_addToQueue",
        value: function _addToQueue(t) {
          var _this25 = this;

          var e;
          "function" == typeof t[t.length - 1] && (e = t.pop());
          var r = {
            id: this.ids++,
            tryCount: 0,
            pending: !1,
            args: t,
            flags: Object.assign({
              fromQueue: !0
            }, this.flags)
          };
          t.push(function (t) {
            if (r !== _this25._queue[0]) return;

            for (var _len6 = arguments.length, n = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
              n[_key6 - 1] = arguments[_key6];
            }

            return null !== t ? r.tryCount > _this25._opts.retries && (_this25._queue.shift(), e && e(t)) : (_this25._queue.shift(), e && e.apply(void 0, [null].concat(n))), r.pending = !1, _this25._drainQueue();
          }), this._queue.push(r), this._drainQueue();
        }
      }, {
        key: "_drainQueue",
        value: function _drainQueue() {
          if (0 === this._queue.length) return;
          var t = this._queue[0];
          if (t.pending) return;
          t.pending = !0, t.tryCount++;
          var e = this.ids;
          this.ids = t.id, this.flags = t.flags, this.emit.apply(this, t.args), this.ids = e;
        }
      }, {
        key: "packet",
        value: function packet(t) {
          t.nsp = this.nsp, this.io._packet(t);
        }
      }, {
        key: "onopen",
        value: function onopen() {
          var _this26 = this;

          "function" == typeof this.auth ? this.auth(function (t) {
            _this26._sendConnectPacket(t);
          }) : this._sendConnectPacket(this.auth);
        }
      }, {
        key: "_sendConnectPacket",
        value: function _sendConnectPacket(t) {
          this.packet({
            type: L.CONNECT,
            data: this._pid ? Object.assign({
              pid: this._pid,
              offset: this._lastOffset
            }, t) : t
          });
        }
      }, {
        key: "onerror",
        value: function onerror(t) {
          this.connected || this.emitReserved("connect_error", t);
        }
      }, {
        key: "onclose",
        value: function onclose(t, e) {
          this.connected = !1, delete this.id, this.emitReserved("disconnect", t, e);
        }
      }, {
        key: "onpacket",
        value: function onpacket(t) {
          if (t.nsp === this.nsp) switch (t.type) {
            case L.CONNECT:
              t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
              break;

            case L.EVENT:
            case L.BINARY_EVENT:
              this.onevent(t);
              break;

            case L.ACK:
            case L.BINARY_ACK:
              this.onack(t);
              break;

            case L.DISCONNECT:
              this.ondisconnect();
              break;

            case L.CONNECT_ERROR:
              this.destroy();

              var _e6 = new Error(t.data.message);

              _e6.data = t.data.data, this.emitReserved("connect_error", _e6);
          }
        }
      }, {
        key: "onevent",
        value: function onevent(t) {
          var e = t.data || [];
          null != t.id && e.push(this.ack(t.id)), this.connected ? this.emitEvent(e) : this.receiveBuffer.push(Object.freeze(e));
        }
      }, {
        key: "emitEvent",
        value: function emitEvent(t) {
          if (this._anyListeners && this._anyListeners.length) {
            var _e7 = this._anyListeners.slice();

            var _iterator = _createForOfIteratorHelper(_e7),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _r9 = _step.value;

                _r9.apply(this, t);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          _get(_getPrototypeOf(D.prototype), "emit", this).apply(this, t), this._pid && t.length && "string" == typeof t[t.length - 1] && (this._lastOffset = t[t.length - 1]);
        }
      }, {
        key: "ack",
        value: function ack(t) {
          var e = this;
          var r = !1;
          return function () {
            for (var _len7 = arguments.length, n = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
              n[_key7] = arguments[_key7];
            }

            r || (r = !0, e.packet({
              type: L.ACK,
              id: t,
              data: n
            }));
          };
        }
      }, {
        key: "onack",
        value: function onack(t) {
          var e = this.acks[t.id];
          "function" == typeof e && (e.apply(this, t.data), delete this.acks[t.id]);
        }
      }, {
        key: "onconnect",
        value: function onconnect(t, e) {
          this.id = t, this.recovered = e && this._pid === e, this._pid = e, this.connected = !0, this.emitBuffered(), this.emitReserved("connect");
        }
      }, {
        key: "emitBuffered",
        value: function emitBuffered() {
          var _this27 = this;

          this.receiveBuffer.forEach(function (t) {
            return _this27.emitEvent(t);
          }), this.receiveBuffer = [], this.sendBuffer.forEach(function (t) {
            _this27.notifyOutgoingListeners(t), _this27.packet(t);
          }), this.sendBuffer = [];
        }
      }, {
        key: "ondisconnect",
        value: function ondisconnect() {
          this.destroy(), this.onclose("io server disconnect");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.subs && (this.subs.forEach(function (t) {
            return t();
          }), this.subs = void 0), this.io._destroy(this);
        }
      }, {
        key: "disconnect",
        value: function disconnect() {
          return this.connected && this.packet({
            type: L.DISCONNECT
          }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
        }
      }, {
        key: "close",
        value: function close() {
          return this.disconnect();
        }
      }, {
        key: "compress",
        value: function compress(t) {
          return this.flags.compress = t, this;
        }
      }, {
        key: "volatile",
        get: function get() {
          return this.flags.volatile = !0, this;
        }
      }, {
        key: "timeout",
        value: function timeout(t) {
          return this.flags.timeout = t, this;
        }
      }, {
        key: "onAny",
        value: function onAny(t) {
          return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
        }
      }, {
        key: "prependAny",
        value: function prependAny(t) {
          return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
        }
      }, {
        key: "offAny",
        value: function offAny(t) {
          if (!this._anyListeners) return this;

          if (t) {
            var _e8 = this._anyListeners;

            for (var _r10 = 0; _r10 < _e8.length; _r10++) {
              if (t === _e8[_r10]) return _e8.splice(_r10, 1), this;
            }
          } else this._anyListeners = [];

          return this;
        }
      }, {
        key: "listenersAny",
        value: function listenersAny() {
          return this._anyListeners || [];
        }
      }, {
        key: "onAnyOutgoing",
        value: function onAnyOutgoing(t) {
          return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
        }
      }, {
        key: "prependAnyOutgoing",
        value: function prependAnyOutgoing(t) {
          return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
        }
      }, {
        key: "offAnyOutgoing",
        value: function offAnyOutgoing(t) {
          if (!this._anyOutgoingListeners) return this;

          if (t) {
            var _e9 = this._anyOutgoingListeners;

            for (var _r11 = 0; _r11 < _e9.length; _r11++) {
              if (t === _e9[_r11]) return _e9.splice(_r11, 1), this;
            }
          } else this._anyOutgoingListeners = [];

          return this;
        }
      }, {
        key: "listenersAnyOutgoing",
        value: function listenersAnyOutgoing() {
          return this._anyOutgoingListeners || [];
        }
      }, {
        key: "notifyOutgoingListeners",
        value: function notifyOutgoingListeners(t) {
          if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            var _e10 = this._anyOutgoingListeners.slice();

            var _iterator2 = _createForOfIteratorHelper(_e10),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _r12 = _step2.value;

                _r12.apply(this, t.data);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      }]);

      return D;
    }(l.a);

    function Y(t) {
      t = t || {}, this.ms = t.min || 100, this.max = t.max || 1e4, this.factor = t.factor || 2, this.jitter = t.jitter > 0 && t.jitter <= 1 ? t.jitter : 0, this.attempts = 0;
    }

    Y.prototype.duration = function () {
      var t = this.ms * Math.pow(this.factor, this.attempts++);

      if (this.jitter) {
        var e = Math.random(),
            r = Math.floor(e * this.jitter * t);
        t = 0 == (1 & Math.floor(10 * e)) ? t - r : t + r;
      }

      return 0 | Math.min(t, this.max);
    }, Y.prototype.reset = function () {
      this.attempts = 0;
    }, Y.prototype.setMin = function (t) {
      this.ms = t;
    }, Y.prototype.setMax = function (t) {
      this.max = t;
    }, Y.prototype.setJitter = function (t) {
      this.jitter = t;
    };

    var q = /*#__PURE__*/function (_l$a5) {
      _inherits(q, _l$a5);

      var _super9 = _createSuper(q);

      function q(t, e) {
        var _this28;

        _classCallCheck(this, q);

        var r;
        _this28 = _super9.call(this), _this28.nsps = {}, _this28.subs = [], t && "object" == _typeof(t) && (e = t, t = void 0), (e = e || {}).path = e.path || "/socket.io", _this28.opts = e, Object(p.b)(_assertThisInitialized(_this28), e), _this28.reconnection(!1 !== e.reconnection), _this28.reconnectionAttempts(e.reconnectionAttempts || 1 / 0), _this28.reconnectionDelay(e.reconnectionDelay || 1e3), _this28.reconnectionDelayMax(e.reconnectionDelayMax || 5e3), _this28.randomizationFactor(null !== (r = e.randomizationFactor) && void 0 !== r ? r : .5), _this28.backoff = new Y({
          min: _this28.reconnectionDelay(),
          max: _this28.reconnectionDelayMax(),
          jitter: _this28.randomizationFactor()
        }), _this28.timeout(null == e.timeout ? 2e4 : e.timeout), _this28._readyState = "closed", _this28.uri = t;
        var o = e.parser || n;
        _this28.encoder = new o.Encoder(), _this28.decoder = new o.Decoder(), _this28._autoConnect = !1 !== e.autoConnect, _this28._autoConnect && _this28.open();
        return _this28;
      }

      _createClass(q, [{
        key: "reconnection",
        value: function reconnection(t) {
          return arguments.length ? (this._reconnection = !!t, this) : this._reconnection;
        }
      }, {
        key: "reconnectionAttempts",
        value: function reconnectionAttempts(t) {
          return void 0 === t ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
        }
      }, {
        key: "reconnectionDelay",
        value: function reconnectionDelay(t) {
          var e;
          return void 0 === t ? this._reconnectionDelay : (this._reconnectionDelay = t, null === (e = this.backoff) || void 0 === e || e.setMin(t), this);
        }
      }, {
        key: "randomizationFactor",
        value: function randomizationFactor(t) {
          var e;
          return void 0 === t ? this._randomizationFactor : (this._randomizationFactor = t, null === (e = this.backoff) || void 0 === e || e.setJitter(t), this);
        }
      }, {
        key: "reconnectionDelayMax",
        value: function reconnectionDelayMax(t) {
          var e;
          return void 0 === t ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, null === (e = this.backoff) || void 0 === e || e.setMax(t), this);
        }
      }, {
        key: "timeout",
        value: function timeout(t) {
          return arguments.length ? (this._timeout = t, this) : this._timeout;
        }
      }, {
        key: "maybeReconnectOnOpen",
        value: function maybeReconnectOnOpen() {
          !this._reconnecting && this._reconnection && 0 === this.backoff.attempts && this.reconnect();
        }
      }, {
        key: "open",
        value: function open(t) {
          var _this29 = this;

          if (~this._readyState.indexOf("open")) return this;
          this.engine = new E(this.uri, this.opts);
          var e = this.engine,
              r = this;
          this._readyState = "opening", this.skipReconnect = !1;
          var n = M(e, "open", function () {
            r.onopen(), t && t();
          }),
              o = M(e, "error", function (e) {
            r.cleanup(), r._readyState = "closed", _this29.emitReserved("error", e), t ? t(e) : r.maybeReconnectOnOpen();
          });

          if (!1 !== this._timeout) {
            var _t15 = this._timeout;
            0 === _t15 && n();

            var _r13 = this.setTimeoutFn(function () {
              n(), e.close(), e.emit("error", new Error("timeout"));
            }, _t15);

            this.opts.autoUnref && _r13.unref(), this.subs.push(function () {
              clearTimeout(_r13);
            });
          }

          return this.subs.push(n), this.subs.push(o), this;
        }
      }, {
        key: "connect",
        value: function connect(t) {
          return this.open(t);
        }
      }, {
        key: "onopen",
        value: function onopen() {
          this.cleanup(), this._readyState = "open", this.emitReserved("open");
          var t = this.engine;
          this.subs.push(M(t, "ping", this.onping.bind(this)), M(t, "data", this.ondata.bind(this)), M(t, "error", this.onerror.bind(this)), M(t, "close", this.onclose.bind(this)), M(this.decoder, "decoded", this.ondecoded.bind(this)));
        }
      }, {
        key: "onping",
        value: function onping() {
          this.emitReserved("ping");
        }
      }, {
        key: "ondata",
        value: function ondata(t) {
          try {
            this.decoder.add(t);
          } catch (t) {
            this.onclose("parse error", t);
          }
        }
      }, {
        key: "ondecoded",
        value: function ondecoded(t) {
          var _this30 = this;

          Object(O.c)(function () {
            _this30.emitReserved("packet", t);
          }, this.setTimeoutFn);
        }
      }, {
        key: "onerror",
        value: function onerror(t) {
          this.emitReserved("error", t);
        }
      }, {
        key: "socket",
        value: function socket(t, e) {
          var r = this.nsps[t];
          return r || (r = new D(this, t, e), this.nsps[t] = r), this._autoConnect && r.connect(), r;
        }
      }, {
        key: "_destroy",
        value: function _destroy(t) {
          var e = Object.keys(this.nsps);

          for (var _i = 0, _e11 = e; _i < _e11.length; _i++) {
            var _t16 = _e11[_i];
            if (this.nsps[_t16].active) return;
          }

          this._close();
        }
      }, {
        key: "_packet",
        value: function _packet(t) {
          var e = this.encoder.encode(t);

          for (var _r14 = 0; _r14 < e.length; _r14++) {
            this.engine.write(e[_r14], t.options);
          }
        }
      }, {
        key: "cleanup",
        value: function cleanup() {
          this.subs.forEach(function (t) {
            return t();
          }), this.subs.length = 0, this.decoder.destroy();
        }
      }, {
        key: "_close",
        value: function _close() {
          this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
        }
      }, {
        key: "disconnect",
        value: function disconnect() {
          return this._close();
        }
      }, {
        key: "onclose",
        value: function onclose(t, e) {
          this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, e), this._reconnection && !this.skipReconnect && this.reconnect();
        }
      }, {
        key: "reconnect",
        value: function reconnect() {
          var _this31 = this;

          if (this._reconnecting || this.skipReconnect) return this;
          var t = this;
          if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;else {
            var _e12 = this.backoff.duration();

            this._reconnecting = !0;

            var _r15 = this.setTimeoutFn(function () {
              t.skipReconnect || (_this31.emitReserved("reconnect_attempt", t.backoff.attempts), t.skipReconnect || t.open(function (e) {
                e ? (t._reconnecting = !1, t.reconnect(), _this31.emitReserved("reconnect_error", e)) : t.onreconnect();
              }));
            }, _e12);

            this.opts.autoUnref && _r15.unref(), this.subs.push(function () {
              clearTimeout(_r15);
            });
          }
        }
      }, {
        key: "onreconnect",
        value: function onreconnect() {
          var t = this.backoff.attempts;
          this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
        }
      }]);

      return q;
    }(l.a);

    var F = {};

    function z(t, e) {
      "object" == _typeof(t) && (e = t, t = void 0);

      var r = function (t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var r = arguments.length > 2 ? arguments[2] : undefined;
        var n = t;
        r = r || "undefined" != typeof location && location, null == t && (t = r.protocol + "//" + r.host), "string" == typeof t && ("/" === t.charAt(0) && (t = "/" === t.charAt(1) ? r.protocol + t : r.host + t), /^(https?|wss?):\/\//.test(t) || (t = void 0 !== r ? r.protocol + "//" + t : "https://" + t), n = k(t)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
        var o = -1 !== n.host.indexOf(":") ? "[" + n.host + "]" : n.host;
        return n.id = n.protocol + "://" + o + ":" + n.port + e, n.href = n.protocol + "://" + o + (r && r.port === n.port ? "" : ":" + n.port), n;
      }(t, (e = e || {}).path || "/socket.io"),
          n = r.source,
          o = r.id,
          i = r.path,
          s = F[o] && i in F[o].nsps;

      var a;
      return e.forceNew || e["force new connection"] || !1 === e.multiplex || s ? a = new q(n, e) : (F[o] || (F[o] = new q(n, e)), a = F[o]), r.query && !e.query && (e.query = r.queryKey), a.socket(r.path, e);
    }

    Object.assign(z, {
      Manager: q,
      Socket: D,
      io: z,
      connect: z
    });

    function V(t) {
      return (V = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function W(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, (o = n.key, i = void 0, i = function (t, e) {
          if ("object" !== V(t) || null === t) return t;
          var r = t[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(t, e || "default");
            if ("object" !== V(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === e ? String : Number)(t);
        }(o, "string"), "symbol" === V(i) ? i : String(i)), n);
      }

      var o, i;
    }

    var H = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.device_token = e, this.socket = null, this.socket_audio_transport, this.start();
      }

      var e, r, n;
      return e = t, (r = [{
        key: "start",
        value: function value() {
          var t = this;
          this.socket = z("https://devices.wavoip.com", {
            transports: ["websocket"],
            path: "/".concat(this.device_token, "/websocket")
          }), this.socket.on("audio_transport:create", function (e) {
            var r = e.room,
                n = e.ip,
                o = e.port;
            console.info("[*] creating audio transport"), t.socket_audio_transport = z("".concat(n, ":").concat(o, "/call-").concat(r), {
              transports: ["websocket"],
              path: "/".concat(t.device_token, "/websocket"),
              forceNew: !0
            });
          }), this.socket.on("audio_transport:terminate", function (t) {
            t.room;
          });
        }
      }]) && W(e.prototype, r), n && W(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function G(t) {
      return (G = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    var K = function K(t) {
      return "object" === G(t) && "success" === (null == t ? void 0 : t.type);
    };

    function Q(t) {
      return (Q = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function J(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, (o = n.key, i = void 0, i = function (t, e) {
          if ("object" !== Q(t) || null === t) return t;
          var r = t[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(t, e || "default");
            if ("object" !== Q(n)) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === e ? String : Number)(t);
        }(o, "string"), "symbol" === Q(i) ? i : String(i)), n);
      }

      var o, i;
    }

    var X = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.Socket = e;
      }

      var e, r, n;
      return e = t, (r = [{
        key: "callStart",
        value: function value(t) {
          var e = this,
              r = t.whatsappid;
          return new Promise(function (t, n) {
            try {
              e.Socket.emit("calls:start", r, function (e) {
                try {
                  K(e), t(e);
                } catch (t) {
                  n(t);
                }
              });
            } catch (t) {
              n(t);
            }
          });
        }
      }, {
        key: "endCall",
        value: function value() {
          var t = this;
          return new Promise(function (e, r) {
            t.Socket.emit("calls:end", {}, function (t) {
              K(t) ? e(t) : r(t);
            });
          });
        }
      }, {
        key: "acceptCall",
        value: function value() {
          var t = this;
          return new Promise(function (e, r) {
            t.Socket.emit("calls:accept", {}, function (t) {
              K(t) ? e(t) : r(t);
            });
          });
        }
      }, {
        key: "rejectCall",
        value: function value() {
          var t = this;
          return new Promise(function (e, r) {
            t.Socket.emit("calls:reject", {}, function (t) {
              K(t) ? e(t) : r(t);
            });
          });
        }
      }, {
        key: "mute",
        value: function value() {
          var t = this;
          return new Promise(function (e, r) {
            t.Socket.emit("calls:mute", {}, function (t) {
              K(t) ? e(t) : r(t);
            });
          });
        }
      }, {
        key: "unMute",
        value: function value() {
          var t = this;
          return new Promise(function (e, r) {
            t.Socket.emit("calls:unmute", {}, function (t) {
              K(t) ? e(t) : r(t);
            });
          });
        }
      }]) && J(e.prototype, r), n && J(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }(),
        $ = r(9),
        Z = r.n($);

    function tt(t) {
      return (tt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function et() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      et = function et() {
        return t;
      };

      var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n = Object.defineProperty || function (t, e, r) {
        t[e] = r.value;
      },
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          s = o.asyncIterator || "@@asyncIterator",
          a = o.toStringTag || "@@toStringTag";

      function c(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }

      try {
        c({}, "");
      } catch (t) {
        c = function c(t, e, r) {
          return t[e] = r;
        };
      }

      function u(t, e, r, o) {
        var i = e && e.prototype instanceof l ? e : l,
            s = Object.create(i.prototype),
            a = new S(o || []);
        return n(s, "_invoke", {
          value: _(t, r, a)
        }), s;
      }

      function h(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = u;
      var f = {};

      function l() {}

      function p() {}

      function d() {}

      var y = {};
      c(y, i, function () {
        return this;
      });
      var g = Object.getPrototypeOf,
          v = g && g(g(A([])));
      v && v !== e && r.call(v, i) && (y = v);
      var m = d.prototype = l.prototype = Object.create(y);

      function b(t) {
        ["next", "throw", "return"].forEach(function (e) {
          c(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }

      function w(t, e) {
        var o;
        n(this, "_invoke", {
          value: function value(n, i) {
            function s() {
              return new e(function (o, s) {
                !function n(o, i, s, a) {
                  var c = h(t[o], t, i);

                  if ("throw" !== c.type) {
                    var u = c.arg,
                        f = u.value;
                    return f && "object" == tt(f) && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                      n("next", t, s, a);
                    }, function (t) {
                      n("throw", t, s, a);
                    }) : e.resolve(f).then(function (t) {
                      u.value = t, s(u);
                    }, function (t) {
                      return n("throw", t, s, a);
                    });
                  }

                  a(c.arg);
                }(n, i, o, s);
              });
            }

            return o = o ? o.then(s, s) : s();
          }
        });
      }

      function _(t, e, r) {
        var n = "suspendedStart";
        return function (o, i) {
          if ("executing" === n) throw new Error("Generator is already running");

          if ("completed" === n) {
            if ("throw" === o) throw i;
            return x();
          }

          for (r.method = o, r.arg = i;;) {
            var s = r.delegate;

            if (s) {
              var a = k(s, r);

              if (a) {
                if (a === f) continue;
                return a;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === n) throw n = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = "executing";
            var c = h(t, e, r);

            if ("normal" === c.type) {
              if (n = r.done ? "completed" : "suspendedYield", c.arg === f) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
          }
        };
      }

      function k(t, e) {
        var r = e.method,
            n = t.iterator[r];
        if (void 0 === n) return e.delegate = null, "throw" === r && t.iterator.return && (e.method = "return", e.arg = void 0, k(t, e), "throw" === e.method) || "return" !== r && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + r + "' method")), f;
        var o = h(n, t.iterator, e.arg);
        if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, f;
        var i = o.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, f) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
      }

      function E(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function O(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function S(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(E, this), this.reset(!0);
      }

      function A(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var n = -1,
                o = function e() {
              for (; ++n < t.length;) {
                if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return o.next = o;
          }
        }

        return {
          next: x
        };
      }

      function x() {
        return {
          value: void 0,
          done: !0
        };
      }

      return p.prototype = d, n(m, "constructor", {
        value: d,
        configurable: !0
      }), n(d, "constructor", {
        value: p,
        configurable: !0
      }), p.displayName = c(d, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === p || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : (t.__proto__ = d, c(t, a, "GeneratorFunction")), t.prototype = Object.create(m), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, b(w.prototype), c(w.prototype, s, function () {
        return this;
      }), t.AsyncIterator = w, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var s = new w(u(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? s : s.next().then(function (t) {
          return t.done ? t.value : s.next();
        });
      }, b(m), c(m, a, "Generator"), c(m, i, function () {
        return this;
      }), c(m, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (t) {
        var e = Object(t),
            r = [];

        for (var n in e) {
          r.push(n);
        }

        return r.reverse(), function t() {
          for (; r.length;) {
            var n = r.pop();
            if (n in e) return t.value = n, t.done = !1, t;
          }

          return t.done = !0, t;
        };
      }, t.values = A, S.prototype = {
        constructor: S,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !t) for (var e in this) {
            "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function n(r, n) {
            return s.type = "throw", s.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
                s = i.completion;
            if ("root" === i.tryLoc) return n("end");

            if (i.tryLoc <= this.prev) {
              var a = r.call(i, "catchLoc"),
                  c = r.call(i, "finallyLoc");

              if (a && c) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (a) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var s = i ? i.completion : {};
          return s.type = t, s.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, f) : this.complete(s);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), f;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), O(r), f;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                O(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: A(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), f;
        }
      }, t;
    }

    function rt(t, e, r, n, o, i, s) {
      try {
        var a = t[i](s),
            c = a.value;
      } catch (t) {
        return void r(t);
      }

      a.done ? e(c) : Promise.resolve(c).then(n, o);
    }

    function nt(t) {
      return function () {
        var e = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = t.apply(e, r);

          function s(t) {
            rt(i, n, o, s, a, "next", t);
          }

          function a(t) {
            rt(i, n, o, s, a, "throw", t);
          }

          s(void 0);
        });
      };
    }

    function ot(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, ct(n.key), n);
      }
    }

    function it(t, e, r) {
      return e && ot(t.prototype, e), r && ot(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }

    function st(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function at(t, e, r) {
      return (e = ct(e)) in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function ct(t) {
      var e = function (t, e) {
        if ("object" !== tt(t) || null === t) return t;
        var r = t[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(t, e || "default");
          if ("object" !== tt(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === e ? String : Number)(t);
      }(t, "string");

      return "symbol" === tt(e) ? e : String(e);
    }

    var ut = it(function t() {
      var e = this,
          r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = r.sampleRate,
          o = r.numberOfChannels,
          i = void 0 === o ? 1 : o,
          s = r.latencyHint,
          a = void 0 === s ? 0 : s,
          c = r.workletOptions,
          u = void 0 === c ? {} : c;
      st(this, t), at(this, "aw", void 0), this.mediaStreamTrack = new Promise(function () {
        var t = nt(et().mark(function t(r) {
          var o, s;
          return et().wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return o = new AudioContext({
                    sampleRate: n,
                    numberOfChannels: i,
                    latencyHint: a,
                    channelCount: 1,
                    numberOfOutputs: 1
                  }), t.next = 3, o.suspend();

                case 3:
                  return o.onstatechange = function (t) {}, t.next = 6, o.audioWorklet.addModule(Z.a);

                case 6:
                  r(), (s = new AudioWorkletNode(o, "audio-data-worklet-stream", u)).connect(o.destination), o.resume(), e.aw = s;

                case 11:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e) {
          return t.apply(this, arguments);
        };
      }());
    });

    function ht(t) {
      return (ht = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function ft(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, lt(n.key), n);
      }
    }

    function lt(t) {
      var e = function (t, e) {
        if ("object" !== ht(t) || null === t) return t;
        var r = t[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(t, e || "default");
          if ("object" !== ht(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === e ? String : Number)(t);
      }(t, "string");

      return "symbol" === ht(e) ? e : String(e);
    }

    var pt = function () {
      function t(e) {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (t, e, r) {
          (e = lt(e)) in t ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = r;
        }(this, "audioCtx", new (window.AudioContext || window.webkitAudioContext)()), this.Socket = e, this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      }

      var e, r, n;
      return e = t, (r = [{
        key: "start",
        value: function value(t) {
          this.Socket.socket_audio_transport.on("audio_buffer", function (t) {
            var r = new Uint8Array(t);
            e.aw.port.postMessage({
              buffer: r
            });
          });
          var e = new ut({
            sampleRate: t,
            latencyHint: 0,
            workletOptions: {
              numberOfInputs: 1,
              numberOfOutputs: 1,
              channelCount: 1,
              processorOptions: {
                offset: 0
              }
            }
          });
        }
      }, {
        key: "stop",
        value: function value() {
          console.info("[*] - Audio stream stopped"), this.audioCtx = new (window.AudioContext || window.webkitAudioContext)(), this.Socket.socket_audio_transport.off("audio_buffer");
        }
      }]) && ft(e.prototype, r), n && ft(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }();

    function dt(t) {
      return (dt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function yt(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, vt(n.key), n);
      }
    }

    function gt(t, e, r) {
      return (e = vt(e)) in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    function vt(t) {
      var e = function (t, e) {
        if ("object" !== dt(t) || null === t) return t;
        var r = t[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(t, e || "default");
          if ("object" !== dt(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === e ? String : Number)(t);
      }(t, "string");

      return "symbol" === dt(e) ? e : String(e);
    }

    var mt,
        bt,
        wt = function () {
      function t(e) {
        var r = this;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), gt(this, "qrcode", void 0), gt(this, "device_status", void 0), this.Socket = e, this.qrcode, this.device_status, this.Socket.on("qrcode", function (t) {
          r.qrcode = t;
        }), this.Socket.on("device_status", function (t) {
          r.device_status = t;
        });
      }

      var e, r, n;
      return e = t, (r = [{
        key: "getCurrentQRCode",
        value: function value() {
          var t = this;
          return new Promise(function (e, r) {
            try {
              t.Socket.emit("whatsapp:qrcode", function (r) {
                t.qrcode = r, e(r);
              });
            } catch (t) {
              console.error("Error to get current qrcode", t), r(t);
            }
          });
        }
      }, {
        key: "getCurrentDeviceStatus",
        value: function value() {
          var t = this;
          return new Promise(function (e, r) {
            try {
              t.Socket.emit("whatsapp:device_status", function (r) {
                t.device_status = r, e(r);
              });
            } catch (t) {
              console.error("Error to get current device status", t), r(t);
            }
          });
        }
      }]) && yt(e.prototype, r), n && yt(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t;
    }(),
        _t = r(10),
        kt = r.n(_t);

    function Et(t) {
      return (Et = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function Ot() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      Ot = function Ot() {
        return t;
      };

      var t = {},
          e = Object.prototype,
          r = e.hasOwnProperty,
          n = Object.defineProperty || function (t, e, r) {
        t[e] = r.value;
      },
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          s = o.asyncIterator || "@@asyncIterator",
          a = o.toStringTag || "@@toStringTag";

      function c(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }

      try {
        c({}, "");
      } catch (t) {
        c = function c(t, e, r) {
          return t[e] = r;
        };
      }

      function u(t, e, r, o) {
        var i = e && e.prototype instanceof l ? e : l,
            s = Object.create(i.prototype),
            a = new S(o || []);
        return n(s, "_invoke", {
          value: _(t, r, a)
        }), s;
      }

      function h(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = u;
      var f = {};

      function l() {}

      function p() {}

      function d() {}

      var y = {};
      c(y, i, function () {
        return this;
      });
      var g = Object.getPrototypeOf,
          v = g && g(g(A([])));
      v && v !== e && r.call(v, i) && (y = v);
      var m = d.prototype = l.prototype = Object.create(y);

      function b(t) {
        ["next", "throw", "return"].forEach(function (e) {
          c(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }

      function w(t, e) {
        var o;
        n(this, "_invoke", {
          value: function value(n, i) {
            function s() {
              return new e(function (o, s) {
                !function n(o, i, s, a) {
                  var c = h(t[o], t, i);

                  if ("throw" !== c.type) {
                    var u = c.arg,
                        f = u.value;
                    return f && "object" == Et(f) && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                      n("next", t, s, a);
                    }, function (t) {
                      n("throw", t, s, a);
                    }) : e.resolve(f).then(function (t) {
                      u.value = t, s(u);
                    }, function (t) {
                      return n("throw", t, s, a);
                    });
                  }

                  a(c.arg);
                }(n, i, o, s);
              });
            }

            return o = o ? o.then(s, s) : s();
          }
        });
      }

      function _(t, e, r) {
        var n = "suspendedStart";
        return function (o, i) {
          if ("executing" === n) throw new Error("Generator is already running");

          if ("completed" === n) {
            if ("throw" === o) throw i;
            return x();
          }

          for (r.method = o, r.arg = i;;) {
            var s = r.delegate;

            if (s) {
              var a = k(s, r);

              if (a) {
                if (a === f) continue;
                return a;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === n) throw n = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = "executing";
            var c = h(t, e, r);

            if ("normal" === c.type) {
              if (n = r.done ? "completed" : "suspendedYield", c.arg === f) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
          }
        };
      }

      function k(t, e) {
        var r = e.method,
            n = t.iterator[r];
        if (void 0 === n) return e.delegate = null, "throw" === r && t.iterator.return && (e.method = "return", e.arg = void 0, k(t, e), "throw" === e.method) || "return" !== r && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + r + "' method")), f;
        var o = h(n, t.iterator, e.arg);
        if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, f;
        var i = o.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, f) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
      }

      function E(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function O(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function S(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(E, this), this.reset(!0);
      }

      function A(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var n = -1,
                o = function e() {
              for (; ++n < t.length;) {
                if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
              }

              return e.value = void 0, e.done = !0, e;
            };

            return o.next = o;
          }
        }

        return {
          next: x
        };
      }

      function x() {
        return {
          value: void 0,
          done: !0
        };
      }

      return p.prototype = d, n(m, "constructor", {
        value: d,
        configurable: !0
      }), n(d, "constructor", {
        value: p,
        configurable: !0
      }), p.displayName = c(d, a, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === p || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : (t.__proto__ = d, c(t, a, "GeneratorFunction")), t.prototype = Object.create(m), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, b(w.prototype), c(w.prototype, s, function () {
        return this;
      }), t.AsyncIterator = w, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var s = new w(u(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? s : s.next().then(function (t) {
          return t.done ? t.value : s.next();
        });
      }, b(m), c(m, a, "Generator"), c(m, i, function () {
        return this;
      }), c(m, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (t) {
        var e = Object(t),
            r = [];

        for (var n in e) {
          r.push(n);
        }

        return r.reverse(), function t() {
          for (; r.length;) {
            var n = r.pop();
            if (n in e) return t.value = n, t.done = !1, t;
          }

          return t.done = !0, t;
        };
      }, t.values = A, S.prototype = {
        constructor: S,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !t) for (var e in this) {
            "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function n(r, n) {
            return s.type = "throw", s.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
                s = i.completion;
            if ("root" === i.tryLoc) return n("end");

            if (i.tryLoc <= this.prev) {
              var a = r.call(i, "catchLoc"),
                  c = r.call(i, "finallyLoc");

              if (a && c) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (a) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var s = i ? i.completion : {};
          return s.type = t, s.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, f) : this.complete(s);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), f;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), O(r), f;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                O(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: A(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), f;
        }
      }, t;
    }

    function St(t, e, r, n, o, i, s) {
      try {
        var a = t[i](s),
            c = a.value;
      } catch (t) {
        return void r(t);
      }

      a.done ? e(c) : Promise.resolve(c).then(n, o);
    }

    function At(t) {
      return function () {
        var e = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = t.apply(e, r);

          function s(t) {
            St(i, n, o, s, a, "next", t);
          }

          function a(t) {
            St(i, n, o, s, a, "throw", t);
          }

          s(void 0);
        });
      };
    }

    var xt = function () {
      var t = At(Ot().mark(function t(e, r) {
        return Ot().wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (!mt) {
                  t.next = 3;
                  break;
                }

                return t.next = 3, Pt();

              case 3:
                bt = e, (mt = new kt.a()).init({
                  analyserOptions: {
                    open: !0
                  },
                  processOptions: {
                    processSize: r / 25,
                    numChannels: 1,
                    sampleBits: 16,
                    sampleRate: r
                  },
                  onDataProcess: function onDataProcess(t) {
                    if (mt) {
                      var e = mt.encodePCM(t.buffer);
                      bt.socket_audio_transport.volatile.timeout(250).emit("microphone_buffer", e.buffer);
                    }
                  }
                }), console.info("[*] - Microphone stream initied with samplerate", r);

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function (e, r) {
        return t.apply(this, arguments);
      };
    }(),
        Rt = function () {
      var t = At(Ot().mark(function t() {
        return Ot().wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return console.info("[*] - Microphone stream called started"), t.next = 3, mt.start();

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function () {
        return t.apply(this, arguments);
      };
    }(),
        Pt = function () {
      var t = At(Ot().mark(function t() {
        var e;
        return Ot().wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (!mt) {
                  t.next = 7;
                  break;
                }

                return t.next = 3, mt.stop();

              case 3:
                return e = t.sent, console.info("[*] - Microphone stream stopped with duration", e), mt = null, t.abrupt("return", e);

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function () {
        return t.apply(this, arguments);
      };
    }(),
        Tt = {
      init: xt,
      start: Rt,
      stop: Pt
    };

    function Bt(t) {
      return (Bt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function Ct(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, jt(n.key), n);
      }
    }

    function Lt(t, e, r) {
      return e && Ct(t.prototype, e), r && Ct(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }

    function jt(t) {
      var e = function (t, e) {
        if ("object" !== Bt(t) || null === t) return t;
        var r = t[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(t, e || "default");
          if ("object" !== Bt(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === e ? String : Number)(t);
      }(t, "string");

      return "symbol" === Bt(e) ? e : String(e);
    }

    var Nt = Lt(function t() {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (t, e, r) {
        (e = jt(e)) in t ? Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = r;
      }(this, "connect", function (t) {
        var e = new H(t),
            r = new pt(e),
            n = new X(e.socket),
            o = new wt(e.socket);
        return e.socket.on("connect", function () {}), e.socket.on("disconnect", function (t) {}), e.socket.on("signaling", function (t) {}), e.socket.on("audio_transport:create", function (t) {
          var n = t.room;
          t.sampleRate;
          r.start(16e3, n), Tt.init(e, 16e3), Tt.start();
        }), e.socket.on("audio_transport:terminate", function (t) {
          t.room;
          r.stop(), Tt.stop();
        }), {
          socket: e.socket,
          getCurrentDeviceStatus: function getCurrentDeviceStatus() {
            return o.getCurrentDeviceStatus();
          },
          getCurrentQRCode: function getCurrentQRCode() {
            return o.getCurrentQRCode();
          },
          callStart: function callStart(t) {
            return n.callStart(t);
          },
          endCall: function endCall() {
            return n.endCall();
          },
          acceptCall: function acceptCall() {
            return n.acceptCall();
          },
          rejectCall: function rejectCall() {
            return n.rejectCall();
          },
          mute: function mute() {
            return n.mute();
          },
          unMute: function unMute() {
            return n.unMute();
          }
        };
      });
    });
    e.default = Nt;
  }]);
});